export default {
  jobMatching: {
    frequency: "التكرار",
    salaryAmount: "المبلغ",
    noCountries: "لا توجد دول أخرى تطابق بحثك.",
    allLevels: "اتركه فارغاً لتضمين جميع المستويات.",
    searchValidationError: "تحقق من الراتب والعملة وفلاتر البحث قبل الحفظ.",
    jobPreferences: "تفضيلات الوظائف",
    employerPreferences: "تفضيلات صاحب العمل",
    companySettings: "إعدادات الشركة",
    countries: "الدول",
    countryHelp: "استخدم دولة سيرتك الذاتية الرئيسية، أو اختر الدول التي تريد العمل فيها.",
    mainCvCountry: "دولة سيرتي الذاتية الرئيسية",
    searchCountries: "البحث عن دولة",
    relocationHelp: "تنطبق الدول المختارة على العمل عن بُعد أيضاً. تتطلب التنبيهات تحديد دولة الوظيفة.",
    cities: "المدن (اختياري)",
    excludedRoles: "المسميات المستبعدة",
    excludedCompanies: "الشركات المستبعدة",
    commaSeparated: "افصل بين العناصر بفواصل",
    seniority: "المستوى الوظيفي",
    minimumSalary: "الحد الأدنى للراتب (اختياري)",
    currency: "العملة، مثل AED",
    monthly: "شهرياً",
    yearly: "سنوياً",
    unknownSalary: "تضمين الوظائف التي لا تعرض راتباً قابلاً للمقارنة",
    workArrangement: "نمط العمل",
    alerts: "تنبيهات الوظائف",
    alertHelp: "احصل على ثلاث وظائف مناسبة كحد أقصى في كل ملخص. يجب تفعيل إشعارات التطبيق.",
    globalPushOff:
      "الإشعارات متوقفة في إعدادات الإشعارات. تبقى تنبيهات الوظائف متوقفة حتى تفعيلها.",
    enableAlerts: "تفعيل تنبيهات الوظائف",
    daily: "يومياً",
    weekly: "أسبوعياً",
    hour: "ساعة الإرسال (0–23)",
    timezone: "المنطقة الزمنية",
    threshold: "الحد الأدنى للتطابق (55–100٪)",
    useDeviceTimezone: "استخدام المنطقة الزمنية للجهاز",
    editSearch: "تعديل تفضيلات البحث عن عمل",
    chooseMainCv: "إدارة سيرتي الذاتية الرئيسية",
    retry: "إعادة المحاولة",
    save: "حفظ إعدادات التنبيهات",
    saved: "تم حفظ إعدادات التنبيهات",
    saveError:
      "تعذر الحفظ. تحقق من الساعة والمنطقة الزمنية ودرجة التطابق ثم حاول مجدداً.",
    levels: {
      entry: "مبتدئ",
      mid: "متوسط",
      senior: "خبير",
      lead: "قائد فريق",
      manager: "مدير",
      director: "مدير إدارة",
      executive: "تنفيذي",
      internship: "تدريب",
    },
  },


  chat: {
    title: "المحادثات",
    newChat: "+ جديد",
    /** زر محادثة جديدة في عمود الدردشة على الويب (تلميح + تسمية وصول). */
    newChatAction: "محادثة جديدة",
    emptyState: "ابدأ محادثة مع مساعدك المهني الذكي",
    emptyTitle: "كيف يمكنني مساعدتك؟",
    emptySubtitle: "اسألني عن مسيرتك أو سيرتك الذاتية أو بحثك عن عمل",
    inputPlaceholder: "أرسل رسالة إلى Tabbio...",
    untitledThread: "محادثة بدون عنوان",
    deleteThreadTitle: "حذف المحادثة؟",
    deleteThreadMessage: "هل تريد حذف «{{title}}»؟ لا يمكن التراجع عن هذا.",
    deleteThreadConfirm: "حذف",
    deleteThreadMenuLabel: "حذف {{title}}",
    deleteThreadSuccess: "تم حذف المحادثة",
    deleteThreadFailed: "تعذر حذف المحادثة",
    deleteThreadFailedMessage: "تمت استعادة المحادثة. يرجى المحاولة مرة أخرى.",
    clearAllHistoryAction: "مسح جميع المحادثات",
    clearAllHistoryTitle: "مسح جميع المحادثات؟",
    clearAllHistoryMessage:
      "سيتم حذف جميع محادثاتك بشكل دائم. لا يمكن التراجع عن هذا.",
    clearAllHistoryConfirm: "مسح الكل",
    clearAllHistoryProgress: "جارٍ مسح المحادثات…",
    clearAllHistorySuccess: "تم مسح جميع المحادثات",
    clearAllHistoryPartial: "تعذر حذف بعض المحادثات",
    clearAllHistoryFailed: "تعذر مسح المحادثات",
    editPrompt: "تعديل",
    editMessageTitle: "تعديل الرسالة",
    editMessagePlaceholder: "عدّل رسالتك",
    cancelEdit: "إلغاء",
    saveEdit: "حفظ",
    editSendFailedTitle: "تعذر حفظ التعديل",
    editSendFailedMessage: "يرجى المحاولة مرة أخرى.",
    suggestions: {
      buildCV: "طابِقني مع الوظائف",
      buildCVSub: "حسب ملفي الشخصي",
      findJobs: "ابحث عن وظائف",
      findJobsSub: "في جميع الإعلانات",
      tailorCV: "خصّص سيرتي الذاتية",
      tailorCVSub: "لوظيفة محددة",
      prepInterview: "تدرّب على مقابلة",
      prepInterviewSub: "بأسئلة خاصة بالوظيفة",
      findRoles: "ابحث عن وظائف تناسبني",
      linkedinPost: "اكتب منشور لينكدإن لهذا الأسبوع",
      industryBriefing: "أرسل لي ملخصاً يومياً عن مجالي",
    },
    feedback: {
      goodResponse: "رد جيد",
      badResponse: "غير مفيد",
      updateFailed: "تعذر حفظ ملاحظاتك. يرجى المحاولة مرة أخرى.",
    },
    cvOnePage: {
      enabledTitle: "وضع الصفحة الواحدة مفعّل",
      enabledBody:
        "سيستخدم ملف PDF تنسيقًا أكثر كثافة عند الحاجة. إذا كان في صفحة واحدة بالفعل فقد لا يتغير مظهره.",
      alreadyEnabledTitle: "وضع الصفحة الواحدة كان مفعّلًا بالفعل",
      alreadyEnabledBody: "لم تكن هناك حاجة إلى تغيير إضافي في التنسيق.",
      disabledTitle: "وضع الصفحة الواحدة متوقف",
      disabledBody: "سيستخدم ملف PDF التنسيق العادي.",
      alreadyDisabledTitle: "وضع الصفحة الواحدة كان متوقفًا بالفعل",
      alreadyDisabledBody: "لم تكن هناك حاجة إلى تغيير التنسيق.",
      viewCv: "عرض السيرة الذاتية",
      cardLabel: "تنسيق السيرة الذاتية",
    },
    // وسم داخل مربع الكتابة يوضح الشاشة التي سيعمل عليها الوكيل.
    pageTag: {
      cv: "السيرة الذاتية",
      cvTailored: "سيرة مخصصة",
      cvHub: "سيري الذاتية",
      jobs: "الوظائف",
      jobDetail: "هذه الوظيفة",
      skills: "المهارات",
      automation: "الأتمتة",
      connectors: "الموصلات",
      memory: "الذاكرة",
      messages: "الرسائل",
      notifications: "الإشعارات",
      analytics: "التحليلات",
      applicationStudio: "أدوات المسيرة المهنية",
    },
    // مقدمات خاصة بكل شاشة لعمود المحادثة في الويب. عدة صيغ للرسالة نفسها
    // لكل شاشة حتى تبدو الزيارات المتكررة مختلفة. أبقِ العربية والإنجليزية
    // متطابقتين في المفاتيح.
    routeIntro: {
      cvHub: {
        m1: "سيرك الذاتية هنا. هل تريد إنشاء سيرة جديدة أم اختيار سيرة للعمل عليها؟",
        m2: "أخبرني بالوظيفة التي تفكر فيها لنختار السيرة الذاتية المناسبة لها.",
        m3: "يمكننا إنشاء سيرة ذاتية أو مقارنة نسخك أو تنظيم مجموعة سيرك.",
        chips: {
          create: "إنشاء سيرة ذاتية",
          choose: "اختيار سيرة لوظيفة",
          manage: "استعراض سيري الذاتية",
        },
      },
      cv: {

        m1: "ما الذي تريد تحسينه في سيرتك الذاتية؟",
        m2: "يمكننا العمل على الملخص أو الخبرات أو المهارات أو إعداد نسخة لوظيفة محددة.",
        m3: "هل تريد أن نجعل سيرتك أوضح وأقوى؟",
        m4: "هل يلاحظ مسؤول التوظيف أفضل أعمالك بسرعة؟ لنتحقق.",
        m5: "اختر قسمًا أدناه أو أخبرني بما تريد تغييره.",
        chips: {
          rewriteSummary: "أعد صياغة الملخص",
          strongerBullets: "اجعل النقاط أقوى",
          gaps: "ما الذي ينقصها؟",
          tailor: "خصّصها لوظيفة",
        },
      },
      cvTailored: {
        m1: "هل تريد تعديل هذه السيرة لتناسب الوظيفة؟",
        m2: "يمكننا مقارنتها بسيرتك الأساسية أو جعلها أكثر تركيزًا.",
        m3: "تظل التغييرات في هذه النسخة المخصصة فقط. ما الذي تريد تحسينه؟",
        m4: "هل تريد مراجعة الكلمات المفتاحية أو اختصارها لصفحة واحدة؟",
        m5: "ما الذي تريد تغييره في هذه السيرة المخصصة؟",
        chips: {
          matchKeywords: "طابِق كلمات الوظيفة",
          compare: "قارنها بسيرتي الأساسية",
          tighten: "اختصرها لصفحة واحدة",
        },
      },
      jobs: {
        m1: "ما نوع الوظيفة التي تبحث عنها؟",
        m2: "أخبرني بالوظيفة أو الموقع أو نمط العمل الذي تريده.",
        m3: "هل نضيّق القائمة حسب التطابق أو الموقع أو الراتب أو نمط العمل؟",
        m4: "لا ترى الوظائف المناسبة؟ أخبرني بما تريد البحث عنه.",
        m5: "هل نرتب هذه الوظائف حسب التطابق أم نبدأ بحثًا جديدًا؟",
        chips: {
          remoteGcc: "وظائف عن بُعد في الخليج",
          bestMatches: "أيها يناسبني أكثر؟",
          recent: "نُشرت هذا الأسبوع",
          easyApply: "التقديم المباشر",
        },
      },
      jobDetail: {
        m1: "هل تريد معرفة مدى ملاءمة هذه الوظيفة لملفك؟",
        m2: "يمكننا مقارنة الوظيفة بخبرتك وتحديد أي فجوات.",
        m3: "هل تريد تخصيص سيرتك أو التدرب للمقابلة؟",
        m4: "مهتم بهذه الوظيفة؟ يمكنني تجهيز الطلب لتراجعه.",
        m5: "ماذا تريد أن تفعل بهذه الوظيفة؟",
        chips: {
          fit: "ما مدى ملاءمتي؟",
          tailor: "خصّص سيرتي لها",
          apply: "جهّز طلبي",
          prep: "حضّرني للمقابلة",
        },
      },
      skills: {
        m1: "ما الذي تريد تحسينه؟",
        m2: "ابحث عن مهارة لسيرتك أو مقابلتك أو بحثك عن عمل.",
        m3: "اختر مهارة أدناه أو أخبرني بما تحتاج إليه.",
        m4: "هل تريد رؤية مهارات السيرة المتاحة؟",
        m5: "لست متأكدًا من أين تبدأ؟ أخبرني بهدفك وسأقترح مهارة.",
        chips: {
          recommend: "اقترح مهارة",
          run: "اعرض مهارات السيرة",
          explain: "ما هي المهارات؟",
        },
      },
      automation: {
        m1: "ما الذي تريد من Nova أن تتولاه؟",
        m2: "راجع أتمتاتك الحالية أو جهّز مسودة جديدة.",
        m3: "هل تريد مراجعة النشاط الأخير أو إنشاء بحث أسبوعي عن وظائف؟",
        m4: "أخبرني بما تريد البحث عنه وعدد مرات التشغيل. سأجهز مسودة لتراجعها.",
        m5: "لن يعمل شيء قبل موافقتك. ما الذي تريد إعداده؟",
        chips: {
          setUp: "أنشئ مسودة تقديم تلقائي",
          review: "راجع النشاط والقواعد",
          rules: "أنشئ مسودة بحث أسبوعي",
        },
      },
      connectors: {
        m1: "أي تطبيق تريد ربطه؟",
        m2: "اسأل عما يفعله كل موصل قبل إعداده.",
        m3: "هل تريد استخدام Tabbio مع ChatGPT أو Claude أو Gemini أو Grok؟",
        m4: "هل تحتاج مساعدة في ربط مساعد ذكاء اصطناعي متاح؟",
        m5: "اختر موصلًا أدناه أو اسألني عن الأنسب لك.",
        chips: {
          which: "اقترح موصلًا",
          linkedin: "اربط مساعد ذكاء اصطناعي",
        },
      },
      memory: {
        m1: "هل تريد مراجعة ما أتذكره عن مسيرتك؟",
        m2: "يمكنك مراجعة أي معلومة هنا أو تصحيحها.",
        m3: "هل توجد معلومة قديمة هنا؟",
        m4: "تؤثر هذه المعلومات في النصائح التي تحصل عليها. ما الذي نراجعه؟",
        m5: "أخبرني بما تريد إضافته أو تغييره أو حذفه.",
        chips: {
          what: "ماذا تتذكر عني؟",
          correct: "صحّح وظيفتي المستهدفة",
        },
      },
      messages: {
        m1: "هل تريد متابعة محادثاتك؟",
        m2: "يمكنني العثور على شخص أو فتح محادثة أو تجهيز رد لموافقتك.",
        m3: "أي محادثة تريد مراجعتها؟",
        chips: {
          unread: "اعرض المحادثات غير المقروءة",
          findPerson: "ابحث عن شخص",
          draftReply: "ساعدني في الرد",
        },
      },
      notifications: {
        m1: "هل تريد مراجعة ما يحتاج إلى انتباهك؟",
        m2: "يمكنني عرض الإشعارات غير المقروءة أو مساعدتك في إدارة إعداداتها.",
        m3: "هل نحدد التنبيهات المكتملة كمقروءة أم نراجع تفضيلات التسليم؟",
        chips: {
          unread: "اعرض التنبيهات غير المقروءة",
          markAllRead: "حدد الكل كمقروء",
          preferences: "راجع التفضيلات",
        },
      },
      analytics: {
        m1: "هل تريد معرفة أداء سيرتك العامة؟",
        m2: "يمكنني تلخيص وصول سيرتك ومصادر المشاهدات الأخيرة.",
        m3: "ما الفترة التي تريد مراجعة أداء السيرة خلالها؟",
        chips: {
          reach: "اعرض وصول 30 يومًا",
          sources: "اعرض مصادر المشاهدات",
          compare: "قارن سيرتي الذاتية",
        },
      },
      applicationStudio: {
        m1: "أي أداة مهنية تريد استخدامها؟",
        m2: "يمكنني تقييم السيرة أو إعداد خطاب تقديم أو مقابلة أو حزمة طلب.",
        m3: "أخبرني بالوظيفة وسأجهز المادة المهنية المناسبة لتراجعها.",
        chips: {
          score: "قيّم سيرتي",
          coverLetter: "اكتب خطاب تقديم",
          interview: "حضّر مقابلة",
          saved: "اعرض النتائج المحفوظة",
        },
      },
    },
    followUps: {
      jobs: {
        applyFirst: "جهّز الطلب الأول",
        refineSearch: "غيّر بحثي",
      },
      cv: {
        tailorForJob: "خصّص هذه السيرة الذاتية لوظيفة",
        browseSkills: "اعرض لي مهارات السيرة الذاتية",
        exportPdf: "تصدير كملف PDF",
      },
      profile: {
        reviewProfile: "مراجعة ملفي الشخصي",
        addExperience: "إضافة خبرة عمل أخرى",
      },
      applications: {
        trackStatus: "تتبع حالة هذا الطلب",
        viewOthers: "عرض طلباتي الأخرى",
      },
      candidates: {
        viewTop: "عرض أفضل مرشح",
        shortlist: "إضافة هذا المرشح للقائمة المختصرة",
      },
    },
    postOnboardingWelcome: {
      title: "مرحباً بك في Tabbio",
      subtitle:
        "مساعدك المهني جاهز. ابدأ مجاناً، ثم استخدم المحادثة والتطبيقات لإنجاز مهمتك المهنية التالية.",
      continueCta: "المتابعة مجاناً",
      close: "إغلاق الترحيب",
      features: {
        chatApply: {
          title: "قدّم عبر المحادثة",
          body: "أخبر Tabbio بالوظيفة. يمكنه تجهيز الخطوة التالية وسؤالك قبل إرسال أي شيء.",
        },
        tailoredCv: {
          title: "سير ذاتية مخصصة",
          body: "حوّل ملفك إلى سيرة مركزة لكل وظيفة.",
        },
        webCv: {
          title: "السيرة الذاتية جاهزة",
          body: "شارك ملفاً واضحاً يمكن للمسؤولين فتحه من أي مكان.",
        },
        jobMatches: {
          title: "مطابقات وتنبيهات الوظائف",
          body: "احصل على وظائف مناسبة وتنبيهات عندما يظهر ما يلائمك.",
        },
      },
    },
    postOnboardingProductTour: {
      nextCta: "التالي",
      openMenuCta: "فتح القائمة",
      openAppsCta: "فتح التطبيقات",
      skipCta: "تخطي الجولة",
      steps: {
        chat: {
          title: "اسأل Tabbio",
          body: "ابدأ بمهمة مهنية واحدة في المحادثة.",
        },
        apps: {
          title: "ابحث عن التطبيقات",
          body: "التطبيقات هي مكان اتصالات Gmail وZapier وMake والتقويم ومصادر MCP.",
        },
        menu: {
          title: "افتح القائمة",
          body: "استخدم القائمة في أي وقت للوصول إلى السيرة الذاتية والسير المشتركة والوظائف والأتمتة والتطبيقات والرسائل والإعدادات.",
        },
      },
    },
  },

  // ربط إضافة المتصفح (/extension/connect)
  extensionConnect: {
    title: "هل تريد ربط تابيو أبلاي؟",
    body: "ستتمكن الإضافة من قراءة سيرك الذاتية وملفك الشخصي لتخصيص الطلبات وتعبئتها نيابة عنك.",
    approve: "اربط الإضافة",
    connecting: "جارٍ الربط",
    done: "تم الربط. يمكنك إغلاق هذه الصفحة.",
    close: "إغلاق الصفحة",
    loading: "جارٍ التحميل",
    grantFailed: "تعذّر بدء الربط. حاول مرة أخرى.",
    notInstalled:
      "تعذّر الوصول إلى الإضافة. تأكد من تثبيتها وتفعيلها ثم حاول مرة أخرى.",
    unknownExtension: "هذه الإضافة غير معروفة.",
    unknownExtensionBody:
      "من أجل سلامتك، لا يرتبط تابيو إلا بالإضافة التي نشرها بنفسه. ثبّت تابيو أبلاي من متجر كروم ثم افتح اللوحة مرة أخرى.",
    subtitle:
      "يقرأ تابيو أبلاي صفحات الوظائف التي تفتحها ويعبّئ الطلبات ببياناتك، ويحتاج إلى الوصول إلى حسابك في تابيو ليقوم بذلك.",
    account: "الحساب الذي سيتم ربطه",
    grantsTitle: "ما الذي ستستطيع الإضافة فعله",
    grants: {
      cvs: {
        title: "قراءة سيرك الذاتية",
        body: "لتخصيص واحدة منها للوظيفة التي تنظر إليها وإرفاقها نيابة عنك.",
      },
      profile: {
        title: "قراءة ملفك الشخصي",
        body: "اسمك وبيانات التواصل وخبراتك، حتى لا تعيد كتابتها في أي نموذج مرة أخرى.",
      },
      control: {
        title: "لن ترسل أي طلب نيابة عنك",
        body: "نعرض عليك كل حقل قبل تعبئته، وأنت من يضغط إرسال. يمكنك فصل الربط في أي وقت من الإعدادات.",
      },
    },
    doneTitle: "تم الربط بنجاح",
    notNow: "ليس الآن",
    retry: "حاول مرة أخرى",
    extensionLabel: "الإضافة",
    desktopOnlyTitle: "افتح هذه الصفحة على جهاز الكمبيوتر",
    desktopOnlyBody:
      "تعمل إضافة تابيو أبلاي في متصفح سطح المكتب. افتح هذا الرابط هناك لربط حسابك.",
  },

  // ربط أداة سطر الأوامر (/cli/connect). يفتح الأمر `tabbio login` هذه الصفحة،
  // والموافقة ترسل رمزاً لمرة واحدة إلى الأداة على هذا الجهاز.
  cliConnect: {
    title: "ربط أداة تابيو لسطر الأوامر",
    subtitle:
      "تطلب أداة تابيو لسطر الأوامر تسجيل الدخول إلى حسابك من جهاز كمبيوتر.",
    loading: "جارٍ التحميل",
    account: "تسجيل الدخول باسم",
    deviceLabel: "الجهاز",
    unknownDevice: "لم يُذكر اسم الجهاز",
    grantsTitle: "ما الذي توافق عليه",
    grants: {
      access: {
        title: "وصول كامل إلى حسابك في تابيو",
        body: "من ذلك الجهاز، تستطيع الأداة فعل كل ما تفعله أنت هنا: قراءة سيرك الذاتية وملفك الشخصي وتعديلها، والبحث عن الوظائف والتقديم عليها، وإرسال الرسائل، وتشغيل وكيلك. وستظل الإجراءات التي تحتاج إلى موافقتك تنتظرها قبل تنفيذها.",
      },
      revoke: {
        title: "يمكنك فصلها في أي وقت",
        body: "شغّل الأمر \u2066tabbio logout\u2069 على ذلك الجهاز لفصلها. وإذا فقدت الجهاز، فغيّر كلمة المرور، فذلك يسجّل خروجك من جميع أجهزتك دفعة واحدة.",
      },
      origin: {
        title: "لا توافق إلا على طلب بدأته بنفسك",
        body: "وافق فقط إذا كنت قد شغّلت الأمر \u2066tabbio login\u2069 بنفسك للتو. وإن لم تفعل، فاضغط إلغاء ولن تتم مشاركة أي شيء.",
      },
    },
    destinationLabel: "سيُرسَل رمز الدخول لمرة واحدة إلى",
    destinationHint:
      "عنوان محلي على هذا الجهاز تنتظر عنده الأداة. لا يعمل إلا في متصفح على الجهاز نفسه الذي شغّلت عليه الأمر \u2066tabbio login\u2069.",
    approve: "وافق واربط",
    connecting: "جارٍ الربط",
    retry: "حاول مرة أخرى",
    cancel: "إلغاء",
    grantFailed: "تعذّر بدء الربط. حاول مرة أخرى.",
    doneTitle: "عُد إلى نافذة الأوامر",
    done: "تُكمل الأداة الآن تسجيل الدخول على جهازك، ويمكنك إغلاق هذه الصفحة. وإذا توقفت نافذة الأوامر عن الانتظار، فشغّل الأمر \u2066tabbio login\u2069 مرة أخرى.",
    close: "إغلاق الصفحة",
    cancelledTitle: "تم إلغاء الربط",
    cancelled: "لم تتم مشاركة أي شيء مع الأداة. يمكنك إغلاق هذه الصفحة.",
    invalidTitle: "رابط تسجيل الدخول هذا غير صالح",
    invalidBody:
      "بعض البيانات التي تضيفها الأداة إلى الرابط ناقصة أو تم تغييرها. شغّل الأمر \u2066tabbio login\u2069 مرة أخرى في نافذة الأوامر للحصول على رابط جديد.",
    impersonationTitle: "لا يمكن ربط الأداة من جلسة دعم",
    impersonationBody:
      "أنت تتصفح حساب شخص آخر لتقديم الدعم. سجّل الدخول بحسابك الخاص لربط أداة تابيو لسطر الأوامر.",
    desktopOnlyTitle: "افتح هذه الصفحة على جهاز الكمبيوتر",
    desktopOnlyBody:
      "يُكمل هذا الرابط تسجيل الدخول إلى أداة تابيو لسطر الأوامر. افتحه في متصفح على الجهاز الذي شغّلت عليه الأمر \u2066tabbio login\u2069.",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
  },

  cv: {
    identityVerified: "الاسم مطابق للهوية المعتمدة عبر UAE PASS؛ المعلومات المهنية يقرّ بها صاحبها",
    review: {
      openEditor: 'تعديل هذه السيرة', openSharing: 'المشاركة والتصدير',
      compareCareerFacts: 'المقارنة مع حقائقي المهنية الحالية', hideCareerFacts: 'إخفاء الحقائق المهنية', currentCareerFacts: 'الحقائق المهنية الحالية',
      libraryPurpose: 'الغرض: {{purpose}}', generalPurpose: 'سيرة مهنية عامة',
      libraryReview: 'المراجعة واللغات والسجل', publicWebCv: 'السيرة العامة على الويب', publishedLink: 'رابط سيرة منشور', privateDraft: 'خاصة',
      factsChangedShort: 'تغيرت الحقائق المهنية · راجع السيرة',
      factsChanged: 'تغيرت الحقائق المهنية منذ مراجعة هذه النسخة. قارنها بهذه السيرة ونسخها اللغوية. تحتفظ المسودات المخصصة والطلبات السابقة بمحتواها المحفوظ.',
      historyNotice: 'اختر نسخة محفوظة لقراءتها. قارن نسختين قبل اختيار المحتوى الذي تريد استعادته.',
      historyEntry: '{{actor}} · {{action}} · {{date}}',
      historyActor: { user: 'المالك', collaborator: 'المتعاون', agent: 'مساعد الذكاء الاصطناعي', skill: 'أداة مهنية', health: 'صحة السيرة', partner: 'الشريك', system: 'النظام' },
      historyAction: { observed: 'تسجيل محتوى سابق', restored: 'استعادة نسخة محفوظة', approved: 'اعتماد نسخة', translationAccepted: 'قبول الترجمة', created: 'إنشاء السيرة', imported: 'استيراد السيرة', health: 'حفظ تحسينات السيرة', generated: 'توليد الصياغة', edited: 'تعديل المسودة' },
      chooseComparison: 'اختر نسخة ثانية للمقارنة', selectVersion: 'اختر النسخة الأولى',
      partialSnapshot: 'تعرض هذه النسخة القديمة النص المحفوظ في هذه السيرة فقط. لم تُسجّل تفاصيل الملف الشخصي الموروثة.',
      selectedHistory: 'النسخة المحفوظة الأولى', comparisonHistory: 'النسخة المحفوظة الثانية',
      before: 'النسخة الأولى', after: 'النسخة الثانية', moreHistory: 'تحميل نسخ أقدم',
      restoreNotice: 'استعد هذا المحتوى كمسودة جديدة. تحتفظ النسخ المعتمدة والروابط العامة والطلبات السابقة بمحتواها المحفوظ.',
      restoreVersion: 'استعادة كمسودة جديدة',
      "transitionPending": "يُحفظ إصدارك المشترك السابق قبل تفعيل أدوات الإصدار الجديدة. روابطك الحالية ما زالت تعمل.",
      "approvedVersion": "الإصدار المعتمد للنشر",
      "compareSource": "المقارنة مع المصدر الحالي",
      "hideSource": "إخفاء مقارنة المصدر",
      "currentSource": "السيرة المصدر الحالية",
      "capturedSource": "المصدر المستخدم لهذا الاقتراح",
      "proposedVersion": "النص المقترح",
      "legacyObservedAt": "إصدار سابق سُجل في {{date}}",
      "title": "المراجعة والإصدارات",
      "intro": "راجع هذه السيرة الذاتية ونسخها المحفوظة في مكان واحد.",
      "unavailable": "المراجعة غير متاحة لهذه السيرة بعد.",
      "original": "السيرة الأصلية",
      "locale": {
        "en": "الإنجليزية",
        "ar": "العربية"
      },
      "loading": "جارٍ تحميل المراجعة",
      "failed": "تعذر حفظ التغيير. مسودتك ما زالت هنا. حاول مجددًا.",
      "conflict": "تغيرت السيرة. احتفظ بتعديلاتك هنا أو تجاهلها وأعد تحميل آخر إصدار.",
      "blank": "غير مذكور",
      "draftVersion": "إصدار المسودة {{version}}",
      "sourceChanged": "تغير المصدر أو لم يُسجل مصدر لهذه النسخة. قارن الحقائق قبل تأكيدها.",
      "sourceAcknowledgment": "قارنت هذه النسخة بالمصدر الحالي وراجعت الاختلافات.",
      "editEdition": "تعديل هذه النسخة",
      "saveEdition": "حفظ النسخة",
      "discard": "تجاهل تعديلاتي وإعادة التحميل",
      "approvalNotice": "يحفظ الاعتماد هذه السيرة بالضبط بشكل خاص. يبقى إصدارك العام الحالي كما هو.",
      "approve": "اعتماد هذا الإصدار",
      "makePublicMain": "استخدامها كسيرتي الذاتية العامة على الويب",
      "showSelectedPreview": "مراجعة نص السيرة المختارة",
      "hideSelectedPreview": "إخفاء معاينة السيرة",
      "sharedEdition": "النسخة المحفوظة المشتركة: {{locale}}",
      "checkEdition": "فحص هذه النسخة المحفوظة مع صحة السيرة",
      "dateFormat": "استخدم تاريخًا صحيحًا: YYYY أو YYYY-MM أو YYYY-MM-DD. اكتب الحاضر للدور الحالي. مسودتك ما زالت هنا.",
      "healthSavedNotice": "تصف هذه الفحوصات النسخة المحفوظة. عدّل المسودة لإجراء تغييرات ثم افحص الإصدار الجديد.",
      "healthUnavailable": "تعذر فحص هذه النسخة. النص المحفوظ لم يتغير. حاول مجددًا.",
      "saveSharedEdition": "مشاركة هذه النسخة المحفوظة مع التطبيق",
      "publicationNotice": "ينشر هذا الإجراء آخر إصدار معتمد حسب إعدادات الظهور الحالية. اجعل السيرة عامة أولًا.",
      "publish": "نشر الإصدار المعتمد",
      "unpublish": "إلغاء نشر هذه النسخة",
      "ownerApproves": "يعتمد المالك الإصدارات ويتحكم في النشر.",
      "translations": "النسخ اللغوية",
      "translationNotice": "الترجمة اقتراح. راجعها هنا قبل قبولها؛ يبقى النص الحالي حتى تقبل الاقتراح.",
      "generate": "اقتراح نسخة {{language}}",
      "proposalAt": "مراجعة اقتراح {{date}}",
      "staleProposal": "أُعد الاقتراح قبل آخر تعديل. ارفضه أو أنشئ اقتراحًا جديدًا.",
      "uncertaintyAcknowledgment": "راجعت تفاصيل الترجمة غير المؤكدة وعددها {{count}} بمقارنتها بالمصدر.",
      "acceptProposal": "قبول الاقتراح",
      "rejectProposal": "رفض الاقتراح",
      "history": "عرض الإصدارات المحفوظة",
      "hideHistory": "إخفاء الإصدارات المحفوظة",
      "historyVersion": "الإصدار {{version}} · {{date}}",
      "releaseAt": "إصدار محفوظ · {{date}}",
      "noHistory": "لا توجد إصدارات محفوظة بعد.",
      tabs: { review: 'المراجعة', languages: 'اللغات', history: 'السجل' },
      editionSwitch: 'النسخة',
      statusLabel: 'حالة الإصدار',
      status: {
        draftApproved: 'المسودة معتمدة', draftChanged: 'في المسودة تغييرات غير معتمدة', draftNotApproved: 'المسودة غير معتمدة بعد',
        live: 'المنشور: الإصدار المعتمد في {{date}}', liveUndated: 'يوجد إصدار منشور', notLive: 'لا يوجد إصدار منشور بعد',
        liveBadge: 'منشور', notLiveBadge: 'غير منشور',
        liveIsOlder: 'يرى من لديهم رابطك الإصدار المعتمد في {{date}} إلى أن تنشر هذا الإصدار.',
      },
      publishVersion: 'نشر الإصدار المعتمد في {{date}}',
      restoreDraftVersion: 'استعادة إصدار المسودة {{version}} كمسودة جديدة',
      showCompleteVersions: 'عرض النسختين كاملتين', hideCompleteVersions: 'إخفاء النسختين الكاملتين',
      noChanges: 'النص متطابق في الإصدارين.',
      editBar: { editing: 'تعديل هذه النسخة', unsaved: 'تغييرات غير محفوظة', hint: 'احفظ تغييراتك أو تجاهلها للانتقال بين التبويبات.' },
      currentDraft: 'المسودة الحالية',
      versionMeta: 'الإصدار {{version}}',
      showApprovedWording: 'عرض نص الإصدار المعتمد',
      hideApprovedWording: 'إخفاء نص الإصدار المعتمد',
      pendingProposals: 'اقتراحات بانتظار مراجعتك',
      historyGroups: { drafts: 'إصدارات المسودة', editions: 'إصدارات النسخة اللغوية', releases: 'الإصدارات المعتمدة' },
      changes: 'ما الذي تغيّر',
      library: {
        review: 'المراجعة',
        needsReview: 'تحتاج إلى مراجعة',
        languages: 'اللغات',
        languageEdition: 'نسخة لغوية',
        recent: 'آخر التغييرات',
        allVersions: 'كل الإصدارات المحفوظة',
        openFullReview: 'فتح المراجعة كاملة',
        factsChangedHint: 'قارنها قبل أن تعتمد السيرة أو تنشرها.',
        badge: { published: 'منشورة', approved: 'معتمدة', draft: 'مسودة', needsReview: 'تحتاج إلى مراجعة' },
      },
      "fields": {
        "photoIncluded": "تتضمن صورة الملف الشخصي",
        "name": "الاسم",
        "title": "الدور أو المسمى",
        "summary": "الملخص",
        "bio": "نبذة",
        "location": "الموقع",
        "contactEmail": "البريد الإلكتروني",
        "company": "الشركة",
        "employmentType": "نوع التوظيف",
        "startDate": "تاريخ البدء",
        "endDate": "تاريخ الانتهاء",
        "overview": "نظرة عامة",
        "school": "المؤسسة التعليمية",
        "degree": "الدرجة",
        "fieldOfStudy": "مجال الدراسة",
        "description": "الوصف",
        "issuer": "الجهة المصدرة",
        "issueDate": "تاريخ الإصدار",
        "expirationDate": "تاريخ الانتهاء",
        "credentialUrl": "رابط الشهادة",
        "desc": "الوصف",
        "link": "الرابط",
        "bullets": "الإنجاز",
        "category": "الفئة",
        "skill": "المهارة",
        "language": "اللغة"
      },
      "sections": {
        "experiences": "الخبرة",
        "educations": "التعليم",
        "certifications": "الشهادة",
        "highlights": "الإنجاز البارز",
        "projects": "المشروع",
        "skillGroups": "المهارات"
      },
      "followApproved": "متابعة الإصدارات التي أعتمدها",
      "exactVersion": "إرسال هذا الإصدار بالضبط",
      "chooseApproved": "اختر إصدارًا معتمدًا",
      "approvedAt": "معتمد في {{date}}",
      "needsApproval": "اعتمد إصدارًا قبل إنشاء هذا الرابط."
    },
    importEvidence: {
      "title": "أدلة الاستيراد",
      "privateNotice": "يمكنك أنت فقط عرض المصدر ونتائج الاستيراد المحفوظة. قارن بينهما قبل تصحيح التفاصيل المفقودة أو غير المؤكدة. هذه لقطات للاستيراد؛ لا تتضمن التعديلات اليدوية اللاحقة.",
      "details": "مراجعة المصدر والنتيجة",
      "hide": "إخفاء التفاصيل",
      "current": "الاستيراد الحالي",
      "previous": "الاستيراد السابق",
      "captured": "تم الحفظ في {{date}}",
      "missing": "أقسام وردت في المصدر ولم يلتقطها الاستيراد: {{sections}}.",
      "cleared": "سيحذف هذا الاستيراد محتوى الأقسام الحالية: {{sections}}.",
      "fallback": "استخدم هذا الاستيراد طريقة استخراج بديلة. راجع المصدر والنتيجة بعناية.",
      "datePrecision": "تبقى التواريخ المذكورة بالسنة فقط أو بالشهر فقط بهذه الدقة. التواريخ المفقودة أو غير المؤكدة لا تحدد يوماً أو شهراً. تظهر الوظيفة مستمرة فقط إذا ذُكر ذلك صراحةً.",
      "dateCounts": "التواريخ المحفوظة: {{year}} بالسنة فقط، {{month}} بالشهر فقط، {{unknown}} غير مؤكدة.",
      "originalUnavailable": "الملف الأصلي المرفوع غير متاح هنا.",
      "sourceUnavailable": "لم يُحفظ نص المصدر الأصلي لهذا المستند.",
      "qualityUnavailable": "لم تُحفظ معلومات جودة التحليل لهذا المستند.",
      "truncated": "قد يكون نص المصدر المحفوظ غير مكتمل لأنه بلغ الحد الأقصى للنص.",
      "source": "نص المصدر المحفوظ",
      "extracted": "الاستخراج المحفوظ قبل التحسين",
      "parsed": "نتيجة الاستيراد المحفوظة",
      "loadFailed": "تعذّر تحميل أدلة الاستيراد. لم تتغير سيرتك الذاتية.",
      "reviewTitle": "مراجعة استيراد سيرة ذاتية غير مكتمل",
      "reviewBody": "لم تُلتقط بعض تفاصيل المصدر أو سيُحذف محتوى أقسام حالية. راجع ما يلي قبل الحفظ. الإلغاء يحتفظ بالمسودة ولا يغير سيرتك الذاتية.",
      "confirm": "حفظ هذا الاستيراد بعد المراجعة",
      "sourceChanged": "تغير مصدر الاستيراد أو السيرة الذاتية. تم الاحتفاظ بمسودتك. أعد تحليل المصدر ومراجعته قبل الحفظ.",
      "resumeDraft": "متابعة مسودة الاستيراد المحفوظة",
      "resumeReview": "مراجعة الاستيراد مجدداً",
      "sections": {
        "experience": "الخبرة المهنية",
        "experiences": "الخبرة المهنية",
        "education": "التعليم",
        "educations": "التعليم",
        "certifications": "الشهادات",
        "projects": "المشاريع",
        "skills": "المهارات",
        "skillGroups": "المهارات",
        "languages": "اللغات",
        "highlights": "الإنجازات",
        "careerHighlights": "الإنجازات",
        "summary": "الملخص",
        "header": "بيانات التواصل"
      }
    },
    title: "سيرتي الذاتية",
    subtitle: "أنشئ وأدِر ملفات سيرتك الذاتية",
    editor: "محرر السيرة",
    templates: "القوالب",
    preview: "معاينة",
    viewAnalytics: "عرض التحليلات",
    hub: {
      title: "Tabbio الخاص بي",
      cvsTitle: "السير الذاتية",
      copyLink: "نسخ الرابط",
      linkCopied: "تم نسخ الرابط",
      share: "مشاركة",
      verifiedLabel: "موثّق عبر UAE PASS",
      updated: "آخر تحديث {{time}}",
      updatedToday: "حُدّثت اليوم",
      createCv: "إنشاء سيرة ذاتية",
      accountLabel: "الحساب",
      openCv: "فتح السيرة الذاتية",
    },
    list: {
      title: "السير الذاتية",
      searchPlaceholder: "بحث",
      clearSearch: "مسح البحث",
      mainBadge: "الرئيسية",
      masterTitle: "السيرة الرئيسية",
      profileTitle: "سيرة الملف الشخصي",
      masterDescription: "مبنية من ملفك الشخصي في Tabbio",
      relativeTime: {
        now: "الآن",
        minutes: "قبل {{count}} د",
        hours: "قبل {{count}} س",
        days: "قبل {{count}} يوم",
        weeks: "قبل {{count}} أسبوع",
        months: "قبل {{count}} شهر",
        years: "قبل {{count}} سنة",
      },
      forOthers: "لأشخاص آخرين",
      sharedWithMe: "مشاركة معي",
      sentByMe: "أرسلتها",
      emptyTitle: "لا توجد سير ذاتية بعد",
      emptySubtitle: "أنشئ أول سيرة ذاتية للبدء.",
      noResults: "لا توجد سير ذاتية مطابقة لبحثك.",
      openMenu: "خيارات إضافية",
      createAria: "إنشاء سيرة ذاتية",
    },
    menu: {
      open: "فتح",
      rename: "إعادة تسمية",
      makeMain: "اجعلها سيرتي الرئيسية",
      makeNew: "نسخ السيرة الذاتية",
      sharePublicly: "مشاركة علنية",
      versionHistory: "سجل الإصدارات",
      archive: "حذف نهائي",
      comingSoon: "قريباً",
      copyTitle: "نسخة من {{title}}",
      renameTitle: "إعادة تسمية السيرة",
      renamePlaceholder: "اسم السيرة",
      save: "حفظ",
      cancel: "إلغاء",
      mainSaved: "تم تحديث السيرة الرئيسية",
      mainFailed: "تعذّر تحديث السيرة الرئيسية",
      renameFailed: "تعذّرت إعادة تسمية السيرة",
      duplicateSaved: "تم نسخ السيرة",
      duplicateFailed: "تعذّر نسخ السيرة",
      archiveSaved: "تم حذف السيرة نهائياً",
      archiveFailed: "تعذّر حذف السيرة",
      archiveConfirmTitle: "حذف السيرة نهائياً؟",
      archiveConfirmMessage:
        "حذف «{{title}}» نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
      versionHistoryTitle: "سجل الإصدارات",
      versionHistoryEmpty: "لا يوجد نشاط بعد.",
    },
    create: {
      title: "إنشاء سيرة ذاتية",
      forMe: "لنفسي",
      forMeSubtitle: "أنشئ أو ارفع سيرتك الذاتية",
      forOthers: "لشخص آخر",
      forOthersSubtitle: "أنشئ سيرة يمكنه المطالبة بها",
      stepOf: "الخطوة {{current}} من {{total}}",
      steps: {
        source: "ابدأ من",
        tailor: "التخصيص",
      },
      namePlaceholder: "مثال: مهندس خلفية - جوجل",
      nameHint: "اختياري. سنسميها نيابة عنك إذا تركت الحقل فارغًا.",
      nameToggle: "سمِّ هذه السيرة",
      copyTitle: "{{name}} (نسخة)",
      defaultTitle: {
        blank: "سيرة بدون عنوان",
        profile: "سيرتي الذاتية",
      },
      generating: "نكتب سيرتك الذاتية. سيستغرق ذلك ثوانٍ قليلة.",
      source: {
        heading: "من أين نبدأ؟",
        subheading:
          "اختر مصدر محتوى هذه السيرة. يمكنك تخصيصها في الخطوة التالية.",
        label: "ابدأ من",
        existing: "سيرة ذاتية موجودة",
        existingHint: "اختر إحدى سيرك الذاتية للبناء عليها",
        existingEmptyHint: "لا توجد لديك سيرة ذاتية بعد",
        untitledCv: "سيرة بدون عنوان",
        pickerTitle: "اختر سيرة ذاتية",
        defaultCvTag: "السيرة الافتراضية",
        pickerSubtitle: "ستبدأ السيرة الجديدة من التي تختارها هنا.",
        pickerHint: "يفتح قائمة سيرك الذاتية",
        upload: "رفع سيرة ذاتية",
        uploadHint: "PDF أو DOC أو DOCX أو صورة أو نص ملصق",
        uploadReady: "تمت قراءة السيرة. جاهز للمتابعة.",
        uploadReplace: "استبدال",
        blank: "سيرة فارغة",
        blankHint: "ابدأ بسيرة فارغة واملأها بنفسك",
      },
      tailor: {
        heading: "هل تريد تخصيصها؟",
        subheading: "طبّق سيرة ذاتية مخصصة أو استهدف وصفًا وظيفيًا.",
        label: "التخصيص",
        skill: "سيرة ذاتية مخصصة",
        skillHint: "إعادة صياغة جاهزة حسب السوق أو المستوى أو الدور",
        skillNeedsJd: "تحتاج هذه السيرة المخصصة أيضًا إلى الوصف الوظيفي",
        skillPickerTitle: "اختر سيرة ذاتية مخصصة",
        skillPickerSubtitle:
          "من إعداد خبراء التوظيف والمجتمع. كل واحدة تغيّر طريقة كتابة سيرتك الذاتية، قسمًا بقسم.",
        skillInfo:
          "السير الذاتية المخصصة هي إعادة صياغة جاهزة حسب السوق أو المستوى المهني أو الدور.",
        skillFilters: "تصفية السير المخصصة",
        skillMenu: "خيارات السيرة المخصصة",
        viewSkillDetails: "عرض التفاصيل",
        shareSkill: "مشاركة",
        reportSkill: "إبلاغ",
        reportSkillConfirm:
          "هل تريد الإبلاغ عن هذه السيرة المخصصة للمراجعة؟",
        skillPickerOpen: "اختر سيرة ذاتية مخصصة",
        skillPickerChange: "اضغط لاختيار سيرة مخصصة مختلفة",
        skillSearchPlaceholder: "ابحث في السير المخصصة",
        skillSearchEmpty: "لا توجد سير مخصصة تطابق هذا البحث.",
        skillsEmpty: "لا توجد سير مخصصة تناسب نقطة البداية هذه بعد.",
        skillsError: "تعذر تحميل السير المخصصة. حاول بعد قليل.",
        jd: "استهداف وصف وظيفي",
        jdHint: "الصق الإعلان وسنخصص السيرة له",
        jdPlaceholder: "الصق وصفًا وظيفيًا، أو صف الدور الذي تستهدفه.",
        jdAttach: "أرفق إعلان الوظيفة (PDF أو صورة)",
        jdAttachClear: "إزالة المرفق",
        jdAttachFailedTitle: "تعذرت قراءة هذا الملف",
        jdAttachTooLarge:
          "حجم الملف يتجاوز 10 ميغابايت. أرفق ملفًا أصغر أو الصق النص.",
        jdAttachUnreadable:
          "لم نتمكن من قراءة نص من هذا الملف. جرّب ملف PDF أو مستند Word أو صورة واضحة لإعلان الوظيفة.",
      },
      recap: {
        existing: "تبدأ من سيرتك: {{name}}",
        upload: "تبدأ من السيرة التي رفعتها",
        profile: "تبدأ من ملفك في تابيو",
      },
      someoneElse: {
        toggle: "هذه السيرة لشخص آخر",
      },
      actions: {
        back: "رجوع",
        continue: "متابعة",
        create: "إنشاء السيرة",
        createTailored: "إنشاء سيرة مخصصة",
      },
      success: {
        skillTitle: "السيرة المخصصة جاهزة",
        skillBody: "تم تطبيق {{skill}}. جارٍ فتح سيرتك الجديدة.",
      },
      errors: {
        sourceRequired: "اختر أولًا من أين نبدأ",
        sourceCvRequired: "اختر السيرة التي نبدأ منها",
        tailorRequired: "اختر مهارة سيرة ذاتية أو أضف وصفًا وظيفيًا",
        resumeRequired: "ارفع أو الصق سيرة ذاتية أولًا",
        skillRequired: "اختر مهارة سيرة ذاتية أولًا",
        jobDescriptionRequired:
          "أضف على الأقل دورًا مستهدفًا أو وصفًا وظيفيًا قصيرًا.",
        skillInputsRequired: "أجب عن أسئلة المهارة أولًا",
        sourceCvEmpty:
          "لا تحتوي هذه السيرة على خبرات أو تعليم أو إنجازات بعد، لذا لا تجد المهارة ما تعمل عليه.",
        skillNotIncluded: "هذه المهارة غير مشمولة في باقتك.",
        network: "تعذر الوصول إلى الخادم. تحقق من اتصالك وحاول مرة أخرى.",
        tooManyRequests: "محاولات كثيرة. انتظر لحظة ثم حاول مرة أخرى.",
        failedTitle: "تعذر إنشاء السيرة",
        failedBody: "حدث خطأ ما. حاول مرة أخرى.",
      },
    },
    handoff: {
      sendTitle: "إرسال السيرة",
      sendSubtitle: "أرسل هذه السيرة كنسخة أو انقلها عند مطالبة المستلم بها.",
      recipientName: "اسم المستلم",
      recipientNamePlaceholder: "مثال: أمينة حسن",
      recipientEmail: "بريد المستلم",
      recipientEmailPlaceholder: "name@example.com",
      recipientPending: "لم يتم تحديد المستلم",
      modeLabel: "طريقة الإرسال",
      copy: "إرسال نسخة",
      copyDescription: "سيحصل على سيرته الخاصة وتبقى نسختك قابلة للتعديل.",
      transfer: "نقل عند المطالبة",
      transferDescription: "سيحصل على نسخة يملكها وتبقى نسختك كاحتياط.",
      sendInvite: "إرسال الدعوة",
      resendInvite: "إعادة إرسال الدعوة",
      sendShort: "إرسال",
      sendSuccess: "تم إرسال دعوة السيرة",
      sendFailed: "تعذر إرسال دعوة السيرة",
      signInRequired: "سجّل الدخول للمطالبة بهذه السيرة",
      openingInvite: "جارٍ فتح دعوة السيرة",
      inviteTitle: "وصلتك سيرة ذاتية",
      inviteSentBy: "أرسل {{name}} هذه السيرة إليك.",
      inviteTransferNote:
        "{{name}} ينقل هذه السيرة إليك، وتبقى نسخته لديه كاحتياط.",
      chooseUpdate: "تحديث سيرتي الحالية",
      chooseUpdateDescription:
        "سيُستبدل محتوى سيرتك الرئيسية بهذه السيرة. يمكنك مراجعتها قبل المشاركة.",
      chooseCopy: "الاحتفاظ بها كنسخة منفصلة",
      chooseCopyDescription:
        "ستُضاف إلى جانب سيرك الذاتية الحالية دون تغيير أي شيء آخر.",
      confirmUpdateTitle: "استبدال محتوى سيرتك الحالية؟",
      confirmUpdateBody:
        "سيُستبدل محتوى سيرتك الرئيسية (الترويسة والملخص والخبرات والتعليم والمهارات وغيرها) بالسيرة التي وصلتك. لن تُحذف سيرك الذاتية ونسخك الحالية.",
      confirmUpdateCta: "نعم، حدّث سيرتي",
      confirmUpdateCancel: "رجوع",
      claimingTitle: "جارٍ المطالبة بالسيرة",
      claimingBody: "ننشئ نسختك الخاصة.",
      claimUpdatingBody: "نُحدّث سيرتك بالمحتوى الذي وصلك.",
      claimFailedTitle: "تعذر المطالبة بهذه السيرة",
      claimFailedBody: "قد تكون هذه الدعوة منتهية أو ملغاة أو مخصصة لبريد آخر.",
      claimOwnerTitle: "هذه سيرتك الذاتية",
      claimOwnerBody:
        "أنت من أنشأ هذه الدعوة، لذا لا يوجد ما تطالب به. اطلب ممن أرسلت إليه الدعوة أن يفتح الرابط من حسابه الخاص.",
      claimWrongEmailTitle: "سجّلت الدخول ببريد مختلف",
      claimWrongEmailBody:
        "أُرسلت هذه الدعوة إلى {{email}}. سجّل الخروج ثم سجّل الدخول بهذا البريد للمطالبة بالسيرة.",
      claimWrongEmailBodyGeneric:
        "أُرسلت هذه الدعوة إلى بريد مختلف. سجّل الدخول بالبريد الذي استلم الدعوة للمطالبة بالسيرة.",
      claimExpiredTitle: "انتهت صلاحية هذه الدعوة",
      claimExpiredBody:
        "اطلب من المُرسِل إعادة إرسال دعوة السيرة، ثم افتح الرابط الجديد.",
      claimRetryCta: "حاول مرة أخرى",
      claimExitCta: "الانتقال إلى Tabbio",
      claimProfileNotUpdatedTitle: "السيرة موجودة في حسابك",
      claimProfileNotUpdatedBody:
        "لم نتمكن من تحديث ملفك الشخصي بها. السيرة التي وصلتك محفوظة وجاهزة للفتح.",
      claimOpenCvCta: "افتح السيرة التي وصلتك",
      claimSkippedRolesTitle: "بعض الخبرات بقيت في السيرة فقط",
      claimSkippedRolesBody:
        "بعض الخبرات لم تذكر تاريخ بداية، لذلك بقيت في السيرة التي وصلتك ولم تُضف إلى ملفك الشخصي.",
      status: {
        draft: "مسودة لشخص آخر",
        pendingCopy: "نسخة بانتظار المطالبة",
        pendingTransfer: "نقل بانتظار المطالبة",
        claimedCopy: "نسخة تمت المطالبة بها",
        claimedTransfer: "نسخة احتياط بعد النقل",
        cancelled: "ملغاة",
        expired: "منتهية",
      },
    },
    share: {
      title: "شارك Tabbio الخاص بك",
      done: "تم",
      tabPublic: "عام",
      tabDirect: "مباشر",
      tabDownload: "تحميل",
      publicLink: "رابط عام",
      contactHidden: "معلومات الاتصال مخفية",
      contactHiddenSub: "يمكن للمشاهدين مراسلتك عبر Tabbio",
      cvHidden: "سيرتك الذاتية مخفية",
      directShare: "مشاركة مباشرة",
      directShareDesc: "رابط خاص مع معلومات الاتصال الكاملة",
      resetLink: "إعادة تعيين الرابط",
      linkReset: "تم إعادة تعيين الرابط",
      scanToView: "امسح لعرض السيرة الذاتية",
      downloadQr: "تحميل QR",
      downloadVcard: "تحميل بطاقة الاتصال",
      saveContact: "حفظ جهة الاتصال",
      printShare: "طباعة ومشاركة",
      printShareDesc: "جاهزة للإرسال لأصحاب العمل",
      editInWord: "تعديل في Word",
      editInWordDesc: "تخصيص في Microsoft Word",
      postSocial: "نشر على التواصل",
      postSocialDesc: "مشاركة كصورة",
      importAts: "استيراد إلى ATS",
      importAtsDesc: "لمنصات التوظيف",
      upgradePro: "ترقية إلى Pro ←",
      copy: "نسخ",
      whatsapp: "واتساب",
      linkedin: "لينكدإن",
      email: "بريد",
      privacy: "بالمشاركة أنت توافق على",
      privacyPolicy: "سياسة الخصوصية",
      terms: "الشروط",
      linkCopied: "تم النسخ!",
      nativeShareTitle: "تفقد سيرتي الذاتية",
      downloadPdf: "تحميل PDF",
      downloadPdfDesc: "سيرة ذاتية منسقة بقالبك وألوانك",
      downloadWord: "تحميل Word",
      downloadWordDesc: "مستند .docx قابل للتعديل",
      downloadTxt: "نص عادي",
      downloadTxtDesc: "تنسيق نصي متوافق مع ATS",
      downloadMd: "ماركداون",
      downloadMdDesc: "تنسيق ماركداون منظم",
      plusRequired: "Plus",
      downloadFailed: "فشل التحميل. يرجى المحاولة مرة أخرى.",
      linkCreateFailed: "تعذّر إنشاء رابط خاص",
      linkUnavailable: "عيّن رابطك على Tabbio للمشاركة",
      download: "تحميل",
      downloadOptions: "خيارات التحميل",
      copied: "تم النسخ",
      qr: "رمز QR",
      qrHint: "أي شخص يمسح هذا الرمز يفتح سيرتك الذاتية.",
      qrSave: "حفظ رمز QR",
      qrFailed: "تعذّر حفظ رمز QR.",
      downloadFormat: "تحميل {{format}}",
      hideLogo: "إخفاء شعار Tabbio",
      hideLogoHint: "أزل علامة Tabbio من بطاقتك.",
      customizeCard: "تخصيص البطاقة",
      customizeCardHint: "الخلفية، العنوان، الصورة",
      advanced: "خيارات متقدمة",
      advancedHint: "الظهور، الرابط، النشاط",
      people: "الأشخاص",
      peopleHint: "ادعُ أشخاصًا لعرض هذه السيرة أو تعديلها.",
      upgrade: "ترقية",
      shareVia: "مشاركة",
      // ─── شاشة المشاركة المعاد تصميمها ───
      includeContact: "تضمين الهاتف والبريد",
      openCv: "فتح السيرة",
      // The share card's default call to action (the "View CV" preset; it opens the CV).
      cardCta: "عرض السيرة الذاتية",
      downloadCv: "تحميل السيرة",
      privacyControls: "إعدادات الخصوصية",
      contact: {
        title: "مشاركة مع معلومات التواصل",
        intro: "يعرض هذا الرابط سيرتك المعتادة ورقم هاتفك وبريدك الإلكتروني.",
        forwardHint: "يمكن لأي شخص لديه الرابط إعادة إرساله. يمكنك إلغاؤه في أي وقت.",
        create: "إنشاء رابط",
        createNew: "إنشاء رابط جديد",
        readyIntro: "سيرتك ورقم هاتفك وبريدك الإلكتروني مضمّنة.",
        linkLabel: "رابط التواصل",
        readyHint: "يمكن لأي شخص لديه الرابط إعادة إرساله.",
        revoke: "إلغاء الرابط",
        revokedTitle: "تم إلغاء الرابط",
        revokedBody: "لم يعد الرابط القديم يفتح سيرتك.",
        linkReady: "رابط السيرة جاهز",
        linkRevoked: "تم إلغاء الرابط",
        revokeFailed: "تعذّر إلغاء هذا الرابط",
      },
      privateLink: "رابط خاص يمكنك إلغاؤه في أي وقت",
      privateLinkStale: "لا يزال يعرض إعداد الهاتف والبريد السابق",
      linkUpdateFailed: "لم نتمكن من تحديث هذا الرابط",
      preparingPrivateLink: "جارٍ تجهيز الرابط الخاص...",
      retry: "إعادة المحاولة",
      addToLinkedin: "أضف إلى لينكدإن",
      access: "الوصول",
      downloadAs: "تحميل بصيغة",
      free: "مجاني",
      qrTitle: "رمز QR لسيرتي الذاتية",
      qrSubtitle: "امسح لفتح سيرتي الذاتية.",
      // شاشة الوصول
      accessTitle: "أنت تقرر من يراك",
      accessSubtitle: "خصوصيتك بين يديك، غيّرها متى شئت",
      accessPublic: "عام",
      accessPublicHint: "جهات الاتصال غير ظاهرة لأصحاب العمل",
      accessEmployers: "أصحاب العمل فقط",
      accessEmployersHint: "تبقى سيرتك مخفية عن العامة",
      accessPrivate: "خاص تمامًا",
      accessPrivateHint: "لا شيء مشترك",
      owner: "المالك",
      you: "(أنت)",
      inviteByEmail: "ادعُ عبر البريد",
      invite: "دعوة",
      inviteHint:
        "يمكن للأشخاص المدعوين تعديل سيرتك. تبقى أنت المالك ويمكنك إزالة الوصول في أي وقت.",
      // شاشة لينكدإن
      linkedinTitle: "المشاركة على لينكدإن",
      linkedinSubtitle: "أضف سيرتك إلى ميزات ملفك على لينكدإن",
      // شرط السيرة العامة ينطبق على كل منصات المشاركة لا على لينكدإن وحده، لذا
      // تذكر الرسالة المنصة التي اختارها المستخدم فعلًا.
      platformPublicRequired:
        "تحتاج المعاينة على {{platform}} إلى سيرة ذاتية عامة. اختر الوصول العام، ثم انسخ رابط Tabbio القصير.",
      // نفس الشرط عند الوصول إليه من تنبيه القفل بجانب الرابط، حيث لا توجد
      // منصة معيّنة.
      linkPublicRequired:
        "لا يعمل رابط Tabbio إلا عندما تكون سيرتك عامة. اختر الوصول العام لمشاركته.",
      goToLinkedin: "الذهاب إلى لينكدإن",
      // يظهر أسفل الرابط العام ويفتح إعدادات الوصول عند الضغط عليه.
      profilePrivateNotice:
        "رابط Tabbio غير متاح ما دام ملفك الشخصي خاصًا. اضغط لجعله عامًا.",
    },
    advanced: {
      title: "خيارات متقدمة",
    },
    customizeCard: {
      // عنوان أداة تخصيص تخطيط السيرة (CustomizeBottomSheet) ما زال هنا.
      title: "تخصيص المعاينة",
      // ─── "تعديل معاينة المشاركة": محرّر بطاقة المشاركة (جرّب أولًا ثم احفظ) ───
      editorTitle: "تعديل معاينة المشاركة",
      trialNote: "جرّب أي نمط تريده. يلزم اشتراك بريميوم لحفظ الخيارات المدفوعة.",
      premium: "بريميوم",
      theme: "نمط البطاقة",
      themes: {
        white: "أبيض",
        black: "أسود",
        tabbio: "Tabbio",
        custom: "مخصص",
        aurora: "شفق",
        dusk: "غسق",
        uae: "الإمارات",
        saudi: "السعودية",
        qatar: "قطر",
        kuwait: "الكويت",
        bahrain: "البحرين",
        oman: "عُمان",
      },
      customColor: "لون مخصص",
      hexColor: "رمز اللون",
      background: "الخلفية",
      patterns: {
        none: "سادة",
        signature: "Tabbio",
        cv: "سيرة ذاتية",
        orbit: "مدار",
        arch: "حقيبة",
        wave: "موج",
      },
      usePhoto: "استخدام صورة الملف الشخصي",
      name: "الاسم",
      headline: "المسمى الوظيفي",
      buttonText: "نص الزر",
      buttonPresets: "نصوص مقترحة للزر",
      cardLink: "رابط البطاقة",
      clearLink: "مسح",
      resetLink: "إعادة الرابط الافتراضي",
      linkNote: "يظهر في تصميم البطاقة فقط. يستخدم النسخ والمشاركة رابط ملفك على Tabbio.",
      hideLogo: "إخفاء شعار Tabbio",
      addBackgroundImage: "إضافة صورة خلفية",
      upgradeBadge: "ترقية",
      done: "تم",
      removeImage: "إزالة الصورة",
      uploading: "جارٍ الرفع…",
      uploadFailed: "تعذّر رفع الصورة.",
      savePreview: "حفظ المعاينة",
      upgradeToSave: "الترقية للحفظ",
      restoreFree: "استعادة الخيارات المجانية",
      saved: "تم حفظ المعاينة",
    },
    sharePanel: {
      copy: "نسخ",
      copied: "تم النسخ",
      tabs: {
        link: "الرابط",
        people: "الأشخاص",
        download: "تحميل",
        activity: "النشاط",
      },
      language: {
        title: "اللغة",
        subtitle: "أنشئ وشارك نسخة بلغة محددة.",
        original: "الأصلية",
        generateArabic: "إنشاء بالعربية",
        generatingArabic: "جارٍ إنشاء العربية...",
        generatingArabicShort: "جارٍ الإنشاء...",
      },
      visibility: {
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        location: "الموقع",
        links: "روابط التواصل",
        photo: "الصورة",
      },
      link: {
        title: "إعدادات المشاركة",
        defaultLabel: "رابط السيرة",
        languageLabel: "رابط سيرة بلغة محددة",
        allowDownload: "السماح بالتحميل من هذا الرابط",
        create: "إنشاء رابط مباشر",
        createNew: "إنشاء رابط مباشر جديد",
        creating: "جارٍ إنشاء الرابط...",
        publicWebCv: "السيرة العامة",
        saveVisibility: "حفظ الظهور",
      },
      people: {
        title: "الأشخاص الذين لديهم وصول",
        invite: "دعوة محرر",
        inviteShort: "دعوة",
        inviting: "جارٍ الدعوة...",
        emailPlaceholder: "name@example.com",
        accessLink: "رابط وصول السيرة",
        accessLinkEmpty: "ادعُ شخصاً لإنشاء رابط وصول.",
        inviteLinkCreated: "تم إنشاء رابط الدعوة وإرساله بالبريد.",
        grantedDirect: "يمكن لـ {{email}} فتح هذه السيرة من مساحة Tabbio.",
        invalidEmail: "أدخل بريداً إلكترونياً صحيحاً.",
        selfInvite: "أنت تملك هذه السيرة بالفعل.",
        alreadyPending: "لدى {{email}} دعوة معلقة بالفعل.",
        alreadyHasAccess: "لدى {{email}} وصول بالفعل.",
        inviteFailed: "تعذر إرسال هذه الدعوة. حاول مرة أخرى.",
        loadFailed: "تعذر تحميل الأشخاص الذين لديهم وصول.",
        invitedUser: "مستخدم مدعو",
        revoke: "إلغاء الوصول",
        revoking: "جارٍ الإلغاء...",
        revoked: "تم إلغاء الوصول.",
        status: {
          pending: "الدعوة معلقة",
          active: "وصول نشط",
          revoked: "ملغى",
        },
        empty: "لا يوجد أشخاص آخرون لديهم وصول بعد.",
      },
      download: {
        title: "خيارات التحميل",
        download: "تحميل",
        downloading: "جارٍ التحميل...",
      },
      activity: {
        title: "نشاط {{title}}",
        empty: "لا يوجد نشاط بعد.",
      },
    },
    publicShare: {
      loading: "جارٍ تحميل السيرة...",
      subtitle: "سيرة ذاتية مشتركة",
      notFoundTitle: "رابط السيرة غير متاح",
      notFoundBody: "قد يكون الرابط منتهي الصلاحية أو تم إيقافه.",
      downloadFailed: "فشل التحميل. يرجى المحاولة مرة أخرى.",
    },
    accessInvite: {
      signInRequired: "سجّل الدخول لقبول دعوة السيرة",
      acceptingTitle: "جارٍ قبول الدعوة",
      acceptingBody: "نفتح مساحة السيرة المشتركة.",
      failedTitle: "الدعوة غير متاحة",
      failedBody: "قد تكون الدعوة منتهية أو تم استخدامها مسبقاً.",
    },
    // Opening a shared CV the user already has access to (no invite to
    // redeem): see app/cv-grant/[grantId].
    grantHandoff: {
      opening: "جارٍ فتح السيرة المشتركة",
      signInRequired: "سجّل الدخول لفتح السيرة المشتركة",
    },
    sharedWithMe: {
      title: "مشتركة معي",
      pageTitle: "السير المشتركة",
      pageSubtitle: "السير التي يمكنك مراجعتها أو تعديلها للآخرين.",
      loading: "جارٍ التحميل",
      count: "{{count}} سير",
      owner: "من {{owner}}",
      empty: "لا توجد سير مشتركة بعد.",
      emptyBody:
        "اطلب من زميل أو مدير أو مسؤول توظيف مشاركة سيرة معك: بمجرد منحك الوصول، ستظهر هنا لمراجعتها أو تعديلها.",
    },
    accessError: {
      sharedTitle: "السيرة المشتركة غير متاحة",
      sharedBody:
        "قد يكون المالك أزال وصولك، أو لم يعد الرابط صالحًا. اطلب منه مشاركتها مرة أخرى.",
      ownTitle: "تعذر تحميل سيرتك الذاتية",
      ownBody: "تحقق من اتصالك وحاول مرة أخرى.",
      retry: "إعادة المحاولة",
      openMine: "افتح سيرتي",
    },
    edit: {
      projectTitle: "عنوان المشروع",
      projectDescription: "الوصف",
      projectTechnologies: "التقنيات (كل تقنية في سطر)",
      projectLink: "رابط المشروع",
      addProject: "إضافة مشروع",
      projectTitleRequired: "أدخل عنوان المشروع.",
      projectLinkInvalid: "أدخل رابطاً كاملاً يبدأ بـ http أو https.",
      noProjects: "لم تتم إضافة مشاريع بعد.",

      sections: "تعديل السيرة",
      headerContact: "المعلومات الشخصية",
      summary: "الملخص",
      highlights: "أبرز الإنجازات",
      skills: "المهارات",
      experience: "الخبرة",
      education: "التعليم",
      projects: "المشاريع",
      certifications: "الشهادات",
      languages: "اللغات",
      jobPreferences: "تفضيلات العمل",
      jobPreferencesLoadFailed: "تعذر تحميل تفضيلات العمل الخاصة بك.",
      customize: "تخصيص",
      customizeDone: "تم",
      customizeCancel: "إلغاء",
      personalInfo: "المعلومات الشخصية",
      career: "المسيرة المهنية",
      skillsAndLanguages: "المهارات واللغات",
      preferences: "التفضيلات",
      identity: "الهوية",
      name: "الاسم الظاهر في السيرة الذاتية",
      usernameReadOnlyShared: "لا يمكن تغيير اسم مستخدم المالك من سيرة مشتركة.",
      usernameReadOnlyTailored:
        "اسم المستخدم تابع لملفك الرئيسي في Tabbio ولا يتغير لكل سيرة مخصصة.",
      showTabbioLink: "إظهار رابط Tabbio",
      showTabbioLinkHint:
        "يطبع عنوان Tabbio الخاص بك في ترويسة السيرة الذاتية. أوقفه لإخفاء العلامة من السيرة.",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      location: "الموقع",
      linkedinUrl: "رابط LinkedIn",
      websiteUrl: "رابط الموقع",
      profileImage: "الصورة الشخصية",
      profileImageHint: "تُستخدم في سيرتك الذاتية وملفك العام.",
      uploadPhoto: "رفع صورة",
      changePhoto: "تغيير الصورة",
      uploadingPhoto: "جارٍ الرفع...",
      photoUploadFailed: "تعذر رفع صورتك",
      headline: "المسمى المهني",
      summaryText: "الملخص المهني",
      highlightTitle: "العنوان",
      highlightDesc: "الأثر / الوصف",
      addHighlight: "إضافة إنجاز",
      highlightIntro: "أهم الإنجازات في سيرتك الذاتية",
      suggestHighlight: "اقتراح إنجاز",
      suggestedHighlight: "إنجاز مقترح",
      saveSuggestion: "حفظ الاقتراح",
      tryAnotherSuggestion: "اقتراح آخر",
      dismissHighlightSuggestion: "تجاهل الاقتراح",
      noHighlights: "لا توجد إنجازات بعد",
      highlightNumber: "الإنجاز {{number}}",
      tapToEdit: "اضغط للتعديل",
      generateHighlightFailed: "تعذر اقتراح إنجاز",
      noNewHighlightSuggestion: "لم يتوفر اقتراح جديد. حاول مرة أخرى.",
      dragToReorder: "اضغط مطولاً على المقبض ثم اسحب لإعادة الترتيب",
      reorderItem: "إعادة ترتيب {{item}}",
      moveItemUp: "نقل {{item}} لأعلى",
      moveItemDown: "نقل {{item}} لأسفل",
      categoryName: "اسم الفئة",
      addSkill: "إضافة مهارة...",
      addCategory: "إضافة فئة",
      role: "المسمى الوظيفي",
      company: "الشركة",
      locationType: "نوع الموقع",
      locationTypeRemote: "عن بُعد",
      locationTypeOnSite: "في مقر العمل",
      locationTypeHybrid: "هجين",
      employmentType: "نوع التوظيف",
      period: "الفترة",
      overview: "نظرة عامة",
      keyAchievements: "أبرز الإنجازات",
      addBullet: "إضافة إنجاز...",
      addAchievementHint: "اكتب إنجازاً ثم اضغط إضافة أو Enter",
      addPosition: "إضافة منصب",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      currentRole: "أعمل هنا حاليًا",
      degree: "الدرجة العلمية",
      school: "الجامعة / المدرسة",
      year: "السنة",
      description: "الوصف",
      addEducation: "إضافة تعليم",
      noEducation: "لم تتم إضافة أي تعليم بعد",
      certName: "اسم الشهادة",
      issuer: "الجهة المانحة",
      date: "التاريخ",
      credentialUrl: "رابط التحقق من الشهادة",
      credentialUrlHint: "رابط للتحقق من هذه الشهادة (مثل رابط شارة Credly)",
      addCertification: "إضافة شهادة",
      language: "اللغة",
      proficiency: "المستوى",
      addLanguage: "إضافة لغة",
      editLanguage: "تعديل اللغة",
      proficiencyRequired: "مستوى الإتقان مطلوب",
      addLanguageHint: "اكتب اللغة ثم اضغط إضافة أو Enter",
      searchLanguages: "ابحث عن اللغات",
      searchToAddLanguage: "ابحث عن لغة لإضافتها",
      noExperience: "لم تتم إضافة أي خبرة بعد",
      selectProficiency: "اختر المستوى",
      done: "تم",
      proficiencyLevels: {
        elementary: "أساسي",
        limited: "متوسط",
        professional: "مهني",
        fullProfessional: "طليق",
        native: "لغة أم",
      },
      addSkillHint: "اكتب المهارة ثم اضغط إضافة أو Enter",
      add: "إضافة",
      nameRequired: "الاسم مطلوب",
      issuerRequired: "الجهة المانحة مطلوبة",
      dateRequired: "التاريخ مطلوب",
      invalidDate: "تاريخ غير صالح",
      dateInFuture: "لا يمكن أن يكون التاريخ في المستقبل",
      roleRequired: "المسمى الوظيفي مطلوب",
      roleTooShort: "أدخل مسمى وظيفياً كاملاً",
      companyRequired: "اسم الشركة مطلوب",
      startDateRequiredForCurrent:
        "أضف تاريخ البدء قبل تحديد هذه الوظيفة كوظيفتك الحالية",
      startAfterEnd: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
      invalidEmail: "أدخل بريداً إلكترونياً صالحاً",
      invalidUrl: "أدخل رابطاً صالحاً",
      tooLong: "طويل جداً (الحد الأقصى {{max}} حرف)",
      invalidChars: "يرجى إزالة الرموز الخاصة",
      limitReached: "تم بلوغ الحد الأقصى للطول",
      degreeRequired: "الدرجة العلمية مطلوبة",
      schoolRequired: "اسم المؤسسة التعليمية مطلوب",
      invalidYear: "أدخل سنة صالحة",
      skillRequired: "المهارة مطلوبة",
      categoryRequired: "اسم الفئة مطلوب",
      languageRequired: "اللغة مطلوبة",
      unsupportedLanguage: "اختر لغة مدعومة",
      duplicateLanguage: "تمت إضافة هذه اللغة من قبل",
      duplicateSkill: "تمت إضافة هذه المهارة من قبل",
      highlightTitleRequired: "العنوان مطلوب",
      highlightDescRequired: "الوصف مطلوب",
      headlineRequired: "المسمى المهني مطلوب",
      summaryRequired: "الملخص مطلوب",
      openToWorkToggle: "متاح للعمل",
      openToWorkDesc: "أخبر المسؤولين أنك متاح للعمل",
      jobTitles: "المسميات الوظيفية المقترحة",
      searchJobTitle: "ابحث عن الدور / المسمى الوظيفي...",
      addCustomRole: 'إضافة "{{query}}"',
      noMatchingRoles: "لا توجد أدوار مطابقة: اضغط إضافة لاستخدامه على أي حال",
      suggestedRoles: "أدوار مقترحة",
      suggestedSkills: "مهارات مقترحة",
      suggestionsHeading: "اقتراحات",
      acceptAll: "قبول الكل",
      dismissAll: "رفض الكل",
      taxonomySearch: "ابحث عن أدوار أو مهارات",
      addCanonicalRole: "إضافة دور",
      addCanonicalSkill: "إضافة مهارة",
      noSkillsYet: "لا توجد مهارات بعد",
      aiSuggestSkills: "اقترح مهارات",
      addSkillNamed: "إضافة {{skill}}",
      dismissSuggestion: "تجاهل {{skill}}",
      removeSkill: "إزالة {{skill}}",
      removeCategory: "إزالة الفئة",
      locationTypes: "أنواع الموقع",
      preferredLocations: "المواقع المفضلة",
      employmentTypes: "أنواع التوظيف",
      relocation: "الانتقال والإشعار",
      whereTo: "إلى أين؟",
      noticePeriod: "فترة الإشعار",
      morePreferences: "تفضيلات إضافية",
      morePreferencesHint: "الراتب والمستوى الوظيفي والاستثناءات والانتقال وفترة الإشعار",
      morePreferencesSet: "تم تحديد {{n}}",
      save: "حفظ",
      saving: "جارٍ الحفظ...",
      saved: "تم الحفظ",
      saveFailed: "فشل الحفظ",
      remove: "إزالة",
      professionalTitle: "المسمى المهني",
      summaryLabel: "نبذة",
      customizeColor: "اللون",
      customizeLayout: "التنسيق",
      customizePhoto: "الصورة",
      customizePhotoShow: "إظهار الصورة",
      customizePhotoHide: "إخفاء الصورة",
      customizeFitOnePage: "إبقاء ملف PDF في صفحة واحدة",
      customizeFitOnePageHint:
        "يستخدم تنسيقًا أكثر كثافة فقط عندما يحتاج ملف PDF إلى ذلك",
      customizeFitOnePageEnabledHint:
        "وضع الصفحة الواحدة مفعّل. لن يتغير مظهر السير التي تتسع بالفعل",
      completePosition: "بعض التفاصيل ناقصة: أكمل الوظيفة المحددة.",
      deleteItemTitle: "حذف {{object}}؟",
      deleteItemMessage: "هل أنت متأكد من حذف {{object}} من سيرتك الذاتية؟",
      deleteTargets: {
        project: "هذا المشروع",
        position: "هذا المنصب",
        achievement: "هذا الإنجاز",
        education: "هذا السجل التعليمي",
        certification: "هذه الشهادة",
        highlight: "هذا الإنجاز البارز",
        language: "هذه اللغة",
        skillGroup: "مجموعة المهارات هذه",
        skill: "هذه المهارة",
        link: "هذا الرابط",
        jobTitle: "هذا المسمى الوظيفي",
        searchArea: "منطقة البحث هذه",
      },
      delete: "حذف",
      cancel: "إلغاء",
      native: "لغة أم",
      fluent: "طلاقة",
      advanced: "متقدم",
      intermediate: "متوسط",
      basic: "مبتدئ",
      remote: "عن بُعد",
      onSite: "حضوري",
      hybrid: "هجين",
      items: "{{count}} عناصر",
      positions: "{{count}} مناصب",
      entries: "{{count}} إدخالات",
      groups: "{{count}} مجموعات",
      filled: "معبأ",
      empty: "فارغ",
      blankPreviewTitle: "سيرتك الذاتية جاهزة للبناء",
      blankPreviewBody:
        "أضف الخبرة والتعليم والمهارات والمزيد. يمكنك إعادة ترتيب الأقسام أو إخفاؤها في أي وقت.",
      addSections: "إضافة أقسام",
      blankPreviewActionHint: "يفتح محرر أقسام السيرة الذاتية",
      blankEditorTitle: "اختر القسم الأول",
      blankEditorBody:
        "ابدأ بالخبرة أو التعليم أو المهارات. يمكنك تعديل الأقسام أو إعادة ترتيبها أو إخفاؤها لاحقًا.",
      addDetails: "إضافة تفاصيل",
      sectionVisible: "ظاهر",
      sectionHidden: "مخفي",
      showSection: "إظهار القسم",
      hideSection: "إخفاء القسم",
      manageSections: "إدارة",
      doneManaging: "تم",
      sectionOrder: "ترتيب الأقسام",
      shownSections: "الأقسام الظاهرة",
      hiddenSections: "الأقسام المخفية",
      moveSectionUp: "نقل القسم للأعلى",
      moveSectionDown: "نقل القسم للأسفل",
      describeToAI: "صِف للذكاء الاصطناعي",
      describeToAISend: "إنشاء",
      suggestAI: "اقتراح بالذكاء الاصطناعي",
      resuggestAI: "إعادة الاقتراح بالذكاء الاصطناعي",
      spark: {
        enhance: "تحسين",
        enhancing: "جارٍ التحسين…",
        scopeMenu: "اختيار النطاق",
        scopeSection: "هذا القسم",
        scopeFullCv: "السيرة كاملة",
        applySkill: "تطبيق مهارة",
        applySkillComingSoon: "قريباً",
        suggestion: "اقتراح الذكاء الاصطناعي",
        useThis: "استخدام هذا",
        keepOriginal: "الإبقاء على الأصل",
      },
    },
    previewScreen: {
      title: "معاينة السيرة الذاتية",
      profileSummary: "الملخص المهني",
      careerHighlights: "أبرز الإنجازات",
      keySkills: "المهارات الرئيسية",
      professionalExperience: "الخبرة المهنية",
      education: "التعليم",
      projects: "المشاريع",
      certifications: "التراخيص والشهادات",
      verifyCredential: "تحقّق",
      languages: "اللغات",
      present: "حتى الآن",
      openToWork: "متاح للعمل",
      editCv: "تعديل السيرة",
      tailored: "مخصصة",
      customize: "تخصيص",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ!",
      shareWebCv: "مشاركة السيرة الذاتية",
      fullTime: "دوام كامل",
      partTime: "دوام جزئي",
      contract: "عقد",
      freelance: "عمل حر",
      loadError: "تعذر تحميل سيرتك الذاتية",
      retry: "إعادة المحاولة",
      noData: "لا توجد بيانات للسيرة الذاتية بعد",
      noDataSubtitle: "أكمل ملفك الشخصي لرؤية معاينة سيرتك الذاتية",
    },
    bottomBar: {
      cvs: "السير",
      edit: "تعديل",
      theme: "المظهر",
      analytics: "المشاهدات",
      enhance: "تحسين",
      enhanceDefaultPrompt:
        "حسّن السيرة المفتوحة حاليًا في Tabbio مباشرة. حافظ على جميع الحقائق. اختصر الملخص ونقاط الخبرة، واستخدم صياغة واضحة تربط الإجراء بالنتيجة، وأزل التكرار، وأبقِ أقوى المهارات ذات الصلة. لا تخترع تفاصيل ولا تقترح مهارة سيرة ذاتية ما لم أطلب ذلك.",
      enhanceTargetMain:
        "السيرة المستهدفة: سيرتي الرئيسية المبنية على ملفي الشخصي.",
      enhanceTargetTailored: "معرّف السيرة المستهدفة: {{id}}.",
      enhanceSend: "إرسال طلب تعديل السيرة",
    },
    enhance: {
      confirmTitle: "تحسين هذه السيرة الذاتية؟",
      confirmMessage:
        "سيعيد الذكاء الاصطناعي كتابة الملخص والمسمى والمهارات ونقاط الخبرة في مكانها لمزيد من الوضوح والتأثير. تبقى جميع الأدوار، لكن الصياغة الحالية تُستبدل. قد يستغرق ذلك حتى نصف دقيقة.",
      confirmAction: "تحسين",
      successTitle: "تم تحسين السيرة",
      successBody: "أُعيدت كتابة الملخص والنقاط. راجع النتيجة.",
      failedTitle: "تعذر تحسين هذه السيرة",
      failedBody: "حدث خطأ ما. حاول مرة أخرى.",
      aiUnavailable:
        "تحسين الذكاء الاصطناعي غير متاح مؤقتًا. حاول مجددًا بعد بضع دقائق.",
    },
    conflict: {
      title: "تغيّرت هذه السيرة الذاتية على جهاز أو علامة تبويب أخرى",
      messageField:
        "تعديلك ما زال هنا. طبّقه فوق أحدث نسخة، أو تجاهله واحتفظ بالنسخة المحفوظة هناك.",
      messageSection:
        "تعديلك ما زال هنا. تطبيقه يستبدل هذا القسم بالكامل بنسختك، فتضيع أي تغييرات أُجريت هناك على هذا القسم. تجاهله للاحتفاظ بالنسخة المحفوظة هناك.",
      messageConfig:
        "تعديلك ما زال هنا. تطبيقه يستبدل تصميم السيرة (التخطيط واللون والصورة وبطاقة المشاركة) بتصميمك، فتضيع أي تغييرات في التصميم أُجريت هناك. تجاهله للاحتفاظ بالنسخة المحفوظة هناك.",
      apply: "طبّق تعديلي فوقها",
      discard: "تجاهل تعديلي",
      keepEditing: "متابعة التعديل",
    },
    setup: {
      label: "مكتمل",
      progress: "{{percent}}% مكتمل",
      title: "أكمل سيرتك الذاتية",
      openHint: "يفتح قائمة إعداد سيرتك الذاتية",
      optional: "اختياري",
    },
    health: {
      control: "صحة السيرة",
      controlA11y: "صحة السيرة، {{status}}",
      checkThisCv: "افحص هذه السيرة",
      checkAgain: "افحص مجددًا",
      checking: "جارٍ الفحص…",
      looksGood: "تبدو جيدة",
      suggestions_zero: "لا اقتراحات",
      suggestions_one: "اقتراح واحد",
      suggestions_two: "اقتراحان",
      suggestions_few: "{{count}} اقتراحات",
      suggestions_many: "{{count}} اقتراحًا",
      suggestions_other: "{{count}} اقتراح",
      introNoReport:
        "افحص هذه السيرة لتعرف ما يستطيع مسؤولو التوظيف وأنظمة التوظيف وأدوات الذكاء الاصطناعي قراءته.",
      cvChanged: "تغيّرت سيرتك الذاتية. لنفحص أحدث نسخة منها.",
      saved: "تم الحفظ",
      undone: "تم التراجع عن التغيير",
      checkingChanges: "جارٍ فحص التغييرات…",
      updated: "تم التحديث",
      done: "تم",
      saveFailed: "لم تُحفظ تغييراتك بعد.",
      trySavingAgain: "حاول الحفظ مجددًا",
      keepEditing: "متابعة التعديل",
      discardChanges: "تجاهل التغييرات",
      unsavedTitle: "تجاهل تعديلاتك؟",
      close: "إغلاق صحة السيرة",
      openHint: "يفتح تقرير صحة السيرة لهذه السيرة الذاتية",
      addLinkTitle: "أضف رابطًا مهنيًا",
      invalidLink: "لا يبدو هذا رابطًا صالحًا.",
    },
    resumeImportNotice: {
      updatedTitle: "تم استيراد السيرة",
      updatedBody: "تم تحديث سيرتك. راجعها أو أنشئ سيرة مخصصة.",
      expiredTitle: "انتهت صلاحية رابط السيرة",
      expiredBody:
        "انتهت صلاحية رابط الصفحة العامة. سيرتك الذاتية ما زالت جاهزة هنا ويمكنك رفع سيرة أخرى في أي وقت.",
      failedTitle: "استيراد السيرة يحتاج إلى مراجعة",
      failedBody:
        "لم نتمكن من إكمال هذا الاستيراد. يمكنك متابعة العمل من سيرتك الذاتية أو إنشاء نسخة مخصصة أو تجربة رفع آخر.",
      createTailored: "إنشاء سيرة مخصصة",
      uploadAnother: "رفع سيرة أخرى",
      reviewCv: "مراجعة السيرة",
      dismiss: "إخفاء",
    },
    resumeImport: {
      tailoredAction: "استبدال هذه السيرة",
      tailoredActionHint: "استبدال هذه السيرة فقط",
      thisCv: "هذه السيرة الذاتية",
      loadFailed: "لم نتمكن من تحميل هذه السيرة الذاتية.",
      tailoredReplaceWarning: "سيتم استبدال {{name}} فقط.",
      tailoredConfirmTitle: "استبدال {{name}}؟",
      tailoredConfirmMessage: "هل تريد استبدال محتوى هذه السيرة بالتفاصيل التي راجعتها؟ ستبقى صورتها وتصميمها ورابطها العام وإعداداتها كما هي.",
      tailoredSuccessMessage: "تم استبدال هذه السيرة بتفاصيل السيرة الجديدة.",
      conflict: "تم تعديل هذه السيرة أثناء الاستيراد. افتح الاستيراد مجددًا وراجع التفاصيل قبل الاستبدال.",
      title: "تحديث السيرة",
      pageTitle: "ارفع سيرة ذاتية جديدة",
      pageSubtitle:
        "ارفع ملف PDF أو DOC أو DOCX أو TXT أو JPG أو PNG، أو الصق نص السيرة الذاتية.",
      placeholder: "الصق نص السيرة أو أرفق ملفاً",
      replaceWarning: "سيتم استبدال سيرتك الرئيسية.",
      updateAction: "تحديث السيرة",
      updateActionHint:
        "استبدل سيرتك الذاتية الرئيسية برفع سيرة جديدة أو لصق نصها.",
      updateEntireAction: "تحديث السيرة",
      updateEntireActionHint: "استبدال السيرة الرئيسية",
      failedTitle: "فشل الاستيراد",
      failedMessage:
        "تعذر تحديث سيرتك الذاتية. جرّب ملفاً آخر أو الصق نص السيرة.",
      successTitle: "تم تحديث السيرة الذاتية",
      successMessage:
        "تم استبدال سيرتك الذاتية الرئيسية بتفاصيل السيرة الجديدة.",
      cancel: "إلغاء",
      confirmTitle: "استبدال السيرة الذاتية الرئيسية؟",
      confirmMessage: "سيتم استبدال سيرتك الرئيسية بالسيرة الجديدة.",
      exactExtractionNote:
        "كان كاتب الذكاء الاصطناعي غير متاح، لذلك ستُستخدم التفاصيل الدقيقة من الملف دون إعادة صياغة.",
      replacementIncomplete:
        "لم نتمكن من قراءة خبرات عمل أو تعليم أو شهادات من هذا الملف، لذلك بقيت سيرتك الحالية دون تغيير. جرّب ملفًا آخر أو الصق نص السيرة الذاتية.",
      replace: "استبدال",
      sourceImported: "تم استيراد السيرة",
      viewSource: "المصدر",
      revertToSource: "استعادة",
      revertConfirm: "سيتم استبدال سيرتك الرئيسية بالاستيراد الأصلي.",
      revertSuccessTitle: "تمت استعادة السيرة الذاتية",
      revertSuccessMessage:
        "تمت استعادة سيرتك الذاتية الرئيسية من الاستيراد الأصلي.",
      noPreviousBackupTitle: "لا يوجد ما يُستعاد",
      noPreviousBackupMessage:
        "لا توجد سيرة سابقة لاستعادتها. يتم الاحتفاظ بنسخة احتياطية فقط عند استيراد سيرة جديدة فوق سيرة موجودة.",
    },
    tailored: {
      title: "السير الذاتية المخصصة",
      subtitle: "سير ذاتية مخصصة لوظائف محددة",
      create: "سيرة ذاتية مخصصة جديدة",
      createTitle: "إنشاء سيرة ذاتية",
      cvName: "اسم السيرة الذاتية",
      cvNamePlaceholder: "مثال: مهندس خلفي - جوجل",
      sourceLabel: "المصدر",
      sourceAi: "إنشاء بالذكاء الاصطناعي",
      sourceUpload: "رفع سيرة",
      sourceBlank: "البدء فارغاً",
      aiPromptLabel: "الدور المستهدف أو وصف الوظيفة",
      aiPromptPlaceholder:
        "الصق وصف الوظيفة أو اشرح الدور المستهدف. سنخصص العنوان والملخص والمهارات من سيرتك الذاتية الحالية.",
      generateWithAi: "إنشاء بالذكاء الاصطناعي",
      titleRequired: "أضف اسم السيرة أولاً",
      promptRequired: "أضف دوراً مستهدفاً أو وصف وظيفة قصيراً على الأقل.",
      generateFailedTitle: "تعذر إنشاء السيرة",
      generateFailedMessage: "حاول مرة أخرى بدور أو وصف وظيفة أوضح.",
      createFailedTitle: "تعذر إنشاء السيرة",
      createFailedMessage: "حاول مرة أخرى باسم سيرة أو اسم مستلم.",
      blankHint: "ابدأ بسيرة فارغة، ثم أضف الأقسام يدوياً من المحرر.",
      createBlank: "إنشاء سيرة فارغة",
      uploadTitle: "ارفع السيرة أولاً",
      uploadSubtitle:
        "سيتم تحديث سيرتك الذاتية الرئيسية من السيرة، ثم إنشاء سيرة مخصصة من الملف المحدّث.",
      uploadPlaceholder: "الصق نص السيرة أو أرفق ملف السيرة",
      importDefaultTitle: "سيرة مستوردة",
      importFailedTitle: "فشل استيراد السيرة",
      importFailedMessage:
        "تعذر استيراد هذه السيرة. جرّب ملفاً آخر أو الصق نص السيرة.",
      importSuccessTitle: "تم إنشاء السيرة المخصصة",
      importSuccessMessage: "تم تحديث سيرتك الرئيسية وإنشاء سيرة مخصصة.",
      someoneElse: {
        recipientName: "اسم المستلم",
        recipientNamePlaceholder: "مثال: أمينة حسن",
        recipientEmail: "بريد المستلم",
        recipientEmailPlaceholder: "name@example.com",
        delivery: "طريقة الإرسال",
        copy: "إرسال نسخة",
        transfer: "نقل",
        defaultTitle: "سيرة {{name}}",
      },
      emptyTitle: "لا توجد سير ذاتية مخصصة بعد",
      emptySubtitle: "أنشئ سيرة ذاتية مخصصة لكل طلب وظيفي",
      deleteConfirm: "حذف هذه السيرة الذاتية المخصصة؟",
      defaultLabel: "الرئيسية",
      setDefault: "اجعلها الرئيسية",
      defaultSaved: "تم تحديث السيرة الرئيسية",
      defaultFailed: "تعذر تحديث السيرة الرئيسية",
      toolbar: {
        editCv: "تعديل السيرة",
        tailored: "مُخصص",
        updateResume: "تحديث السيرة",
        customize: "تخصيص",
        shareWebCv: "مشاركة السيرة الذاتية",
      },
    },
  },

  jobs: {
    title: "الوظائف",
    subtitle: "لك يرتّب الوظائف بحسب ملفك، والسوق يعرض الكتالوج الأوسع.",
    detail: "تفاصيل الوظيفة",
    handoff: {
      opening: "جارٍ فتح الوظيفة…",
      signInRequired: "سجّل الدخول لعرض هذه الوظيفة والتقديم عليها.",
      openingJoin: "جارٍ فتح شبكة المواهب…",
      signInRequiredJoin: "سجّل الدخول للانضمام إلى شبكة مواهب هذه الشركة.",
    },
    loadingDetail: "جارٍ تحميل تفاصيل الوظيفة",
    loadMore: "تحميل المزيد من الوظائف",
    searchPlaceholder: "صف الوظيفة التي تريدها",
    clearSearch: "مسح بحث الوظائف",
    applyOnWebsite: "التقديم عبر موقع صاحب العمل",
    externalApplyHint: "ستكمل التقديم على موقع صاحب العمل.",
    detailHeader: "وظيفة",
    sourceAttribution:
      "تم العثور عليها عبر {{source}}. يجمع تابيو هذا الإعلان؛ التقديم يأخذك إلى الموقع الأصلي.",
    gatheredFrom: "مجمّعة من LinkedIn وبيت وإنديد والمواقع الرسمية للشركات",
    sectionTopPicksTitle: "أفضل الوظائف لك",
    sectionTopPicksSubtitle:
      "بناءً على سيرتك الذاتية وتفضيلاتك والوظائف المحفوظة",
    sectionMoreJobsTitle: "تصفح سوق الوظائف",
    sectionMoreJobsSubtitle: "وظائف أخرى خارج أفضل المطابقات",
    proCardTitle: "احصل على ردود أسرع مع Tabbio Pro",
    proCardSubtitle:
      "تعرّف على الوظائف التي تراجع المتقدمين بفاعلية ومدى تطابقك معها",
    popupBlockedTitle: "تم حظر النافذة المنبثقة",
    popupBlockedSubtitle:
      "اسمح بالنوافذ المنبثقة لهذا الموقع للمتابعة إلى صفحة التقديم.",
    noApplyTargetTitle: "التقديم غير متاح",
    noApplyTargetSubtitle:
      "لا يمكن التقديم على هذه الوظيفة حاليًا. عاود التحقق لاحقًا أو جرّب وظيفة أخرى.",
    noApplyTargetLabel: "التقديم غير متاح",
    inactiveTitle: "لم تعد هذه الوظيفة تستقبل طلبات التقديم",
    inactiveSubtitle: "أنت تعرض الإعلان التاريخي المحفوظ مع إشعارك.",
    inactiveAction: "أُغلق التقديم",
    trackRedirectFailedTitle: "تعذّر تسجيل هذا التقديم",
    trackRedirectFailedSubtitle:
      "إذا أكملت التقديم، فحدّده يدويًا من قائمة الوظائف المتقدم لها.",
    catalog: {
      source: {
        tabbioNative: "Tabbio",
        googleJobs: "وظائف Google",
        workable: "Workable",
        linkedin: "LinkedIn",
        bayt: "بيت.كوم",
        naukrigulf: "NaukriGulf",
        partnerAts: "أنظمة توظيف الشركات",
        external: "خارجي",
      },
      applyMode: {
        // وسم/تسمية وليس دعوة للإجراء — الفعل مكانه في `cta` أدناه.
        tabbioNative: "بنقرة واحدة",
        externalRedirect: "التقديم في الموقع",
        partnerAtsManaged: "ATS شريك",
      },
      roleTag: "الدور: {{role}}",
      cta: {
        oneTap: "تقديم بنقرة واحدة",
        applyOnSite: "التقديم في الموقع",
        partnerAts: "ATS شريك",
      },
      kind: {
        native: "داخلي",
        external: "خارجي",
      },
    },
    tabs: {
      discover: "لك",
      explore: "السوق",
      saved: "المحفوظة",
      applied: "المتقدم لها",
    },
    shortcuts: {
      preferences: "التفضيلات",
      myJobs: "وظائفي",
      alerts: "التنبيهات",
      liveRefresh: "جلب وظائف مباشرة · {{count}} رصيد",
    },
    actions: {
      save: "حفظ الوظيفة",
      unsave: "إزالة من المحفوظة",
      hide: "إخفاء الوظيفة",
      undo: "تراجع",
      tailorCv: "خصّص سيرة لهذه الوظيفة",
    },
    feedback: {
      saved: "تم حفظ الوظيفة",
      unsaved: "تمت إزالة الوظيفة من المحفوظة",
      hidden: "لن نوصي بهذه الوظيفة مرة أخرى",
      hiddenInline: "تم إخفاء الوظيفة من توصياتك.",
      restored: "تمت استعادة الوظيفة",
      saveFailed: "تعذر تحديث هذه الوظيفة",
      hideFailed: "تعذر إخفاء هذه الوظيفة",
      restoreFailed: "تعذر استعادة هذه الوظيفة",
    },
    preferences: {
      title: "التفضيلات",
      myInterests: "اهتماماتي",
      openToWorkTitle: "متاح للعمل",
      openToWorkSubtitle: "مرئي للمسؤولين عن التوظيف فقط",
      jobAlertsTitle: "تنبيهات الوظائف",
      jobAlertsEnabled: "مطابقة الوظائف والتنبيهات مفعلة",
      jobAlertsDisabled: "فعّل إشعارات الوظائف المطابقة",
      primaryCvSection: "السيرة الأساسية",
      primaryCvTitle: "السيرة الأساسية",
      primaryCvSubtitle: "تظهر للمسؤولين. اضغط للتغيير",
      customCv: "سيرة مخصصة",
      verificationSection: "التحقق",
      verificationTitle: "التحقق من الهوية",
      verificationLinked: "تم التحقق عبر UAE PASS",
      verificationUnlinked: "تحقق عبر UAE PASS لإضافة شارة موثوقة",
      verified: "موثق",
      saved: "تم حفظ التفضيلات",
      saveFailed: "تعذر حفظ التفضيلات",
    },
    primaryCv: {
      title: "السيرة الأساسية",
      subtitle:
        "اختر السيرة التي يراها المسؤولون عن التوظيف عند العثور عليك. يمكنك تغييرها في أي وقت.",
      saved: "تم تحديث السيرة الأساسية",
      saveFailed: "تعذر تحديث السيرة الأساسية",
    },
    alerts: {
      title: "تنبيهات الوظائف",
      subtitle: "إدارة الوظائف المطابقة وطريقة إرسال التنبيهات.",
      defaultRuleTitle: "أفضل الوظائف لك",
      defaultRuleSubtitle: "وظائف مقترحة بناءً على ملفك ونشاطك",
      enabled: "مفعّل",
      disabled: "متوقف",
      topPicksTitle: "أفضل الوظائف لك",
      topPicksSubtitle: "اقتراح وظائف بناءً على ملفك ونشاطك.",
      editTitle: "تعديل التنبيه",
      allAlerts: "كل التنبيهات",
      frequencyLabel: "تكرار التنبيه",
      frequency: {
        daily: "يومي",
        weekly: "أسبوعي",
      },
      notificationType: "نوع الإشعار",
      notification: {
        both: "البريد والإشعار",
        email: "البريد الإلكتروني",
        notification: "إشعار",
      },
      similarJobs: "أبلغني بوظائف مشابهة",
      similarJobsSubtitle: "عند وجود وظائف تطابق هذا التنبيه.",
      saved: "تم تحديث التنبيه",
      saveFailed: "تعذر تحديث التنبيه",
      newAlert: "تنبيه جديد",
    },
    uaePass: {
      title: "التحقق من الهوية",
      unverifiedTitle: "تحقق من هويتك",
      verifiedTitle: "موثق عبر UAE PASS",
      body: "أكد هويتك عبر UAE PASS حتى يثق أصحاب العمل بسيرتك.",
      verifiedBody:
        "حسابك مرتبط بـ UAE PASS. يمكن للمسؤولين رؤية شارة التحقق الموثوقة.",
      governmentIdentity: "هوية بمستوى حكومي",
      onTabbio: "على تابيو",
      since: "منذ {{date}}",
      cvLastUpdated: "آخر تحديث للسيرة الذاتية",
      notUpdatedYet: "لم يتم التحديث بعد",
      dateUnavailable: "التاريخ غير متاح",
      howItWorks: "كيف تعمل عملية التحقق",
      hideHowItWorks: "إخفاء تفاصيل التحقق",
      loadFailed: "تعذر تحميل تفاصيل التحقق.",
      benefitBadge: "يضيف شارة موثوقة إلى كل سيرة تشاركها.",
      benefitName: "يؤكد اسمك القانوني عبر UAE PASS.",
      benefitPrivacy: "لا يظهر رقم الهوية الإماراتية لأصحاب العمل.",
      cta: "المتابعة عبر UAE PASS",
    },
    myJobs: {
      title: "وظائفي",
      saved: "المحفوظة {{count}}",
      applied: "المتقدم لها {{count}}",
      emptySaved: "لا توجد وظائف محفوظة بعد",
      emptySavedSubtitle: "احفظ الوظائف من لك أو السوق لمقارنتها لاحقاً.",
      emptyApplied: "لا توجد طلبات بعد",
      emptyAppliedSubtitle: "ستظهر الوظائف التي تقدمت لها هنا.",
      statusBadge: "متقدم",
      appliedAgo: "تم التقديم {{date}}",
      statusDetail: {
        applied: "لا رد حتى الآن",
        submitted: "لا رد حتى الآن",
        redirected: "قيد المعالجة",
        not_applied: "لم يتم التقديم",
        reviewed: "قيد المراجعة",
        shortlisted: "تم الاختيار المبدئي",
        interview: "تم جدولة مقابلة",
        offered: "تم تقديم عرض",
        rejected: "لم يتم الاختيار",
        withdrawn: "تم السحب",
      },
      talentNetworks: "شبكات المواهب",
      talentNetworkLabel: "شبكة المواهب",
      joinedAgo: "انضممت {{date}}",
      networkStatus: {
        active: "عضو",
        withdrawn: "غادرت",
      },
    },
    talentNetwork: {
      title: "شبكة المواهب",
      status: "الحالة",
      joined: "تاريخ الانضمام",
      left: "تاريخ المغادرة",
      withdrawnNotice: "غادرت شبكة المواهب هذه. يبقى ما أرسلته مسجَّلاً لدى الشركة.",
      notFoundTitle: "لم تعد هذه العضوية متاحة",
      notFoundSubtitle: "ارجع إلى وظائفي لرؤية شبكات المواهب الحالية.",
      loadErrorTitle: "تعذر تحميل شبكات المواهب",
      loadErrorSubtitle: "تحقق من اتصالك وحاول مرة أخرى.",
      retry: "حاول مرة أخرى",
    },
    tailorCv: {
      working: "جارٍ تخصيص سيرتك…",
      progress: "ننشئ سيرة لوظيفة {{title}} لدى {{company}}. يمكنك متابعة قراءة الإعلان.",
      ready: "سيرتك لوظيفة {{title}} لدى {{company}} جاهزة.",
      view: "عرض السيرة المخصصة",
      retry: "إعادة محاولة التخصيص",

      defaultTitle: "سيرة مخصصة لوظيفة {{title}}",
      prompt:
        "خصّص سيرتي الذاتية لوظيفة {{title}} لدى {{company}}. استخدم وصف الوظيفة أدناه كسياق، واجعل كل الادعاءات مبنية على ملفي الحالي فقط.\n\n{{description}}",
    },
    discoverTitle: "لك",
    discoverSubtitle: "وظائف مرتبة بحسب ملفك ومهاراتك",
    discoverSubtitleWithFamily: "وظائف متوافقة مع ملف {{family}} الخاص بك",
    exploreTitle: "السوق",
    exploreSubtitle: "تصفح السوق الأوسع عبر الأدوار والمصادر",
    appliedTitle: "المتقدم لها",
    appliedSubtitle: "الوظائف التي تقدمت لها بالفعل",
    related: {
      title: "وظائف مشابهة ومطابقة",
      subtitle: "أدوار مشابهة مرتبة حسب ملفك وهذه الوظيفة.",
      missingChip: "ينقص {{skill}}",
    },
    noDiscover: "لا توجد وظائف متطابقة بعد",
    noDiscoverSubtitle: "ما زلنا نتعلم ملفك. جرّب السوق لتصفح الكتالوج الأوسع.",
    noDiscoverProfileSubtitle:
      "لا توجد وظائف مطابقة لملف {{family}} بعد. جرّب السوق أو حسّن مهاراتك.",
    noDiscoverImproveProfile:
      "أضف المهارات والأدوار المستهدفة إلى ملفك الشخصي لنتمكن من اقتراح الوظائف المناسبة.",
    noDiscoverImproveProfileCta: "تحسين ملفي",
    noDiscoverCatalogGap:
      "لم نعثر بعد على وظيفة مناسبة في مواقع العمل الحالية. راجع تفضيلات الوظائف أو اجلب إعلانات جديدة.",
    noDiscoverPreferencesCta: "مراجعة تفضيلات الوظائف",
    noDiscoverFilteredSubtitle: "جرّب إزالة بعض الفلاتر أو انتقل إلى السوق.",
    emptyTitle: "لا توجد وظائف لعرضها بعد",
    emptySubtitle: "لا يوجد في الكتالوج ما يطابق ملفك حالياً.",
    emptyProfileSubtitle: "لم تُطابق أي وظيفة ملفك في {{family}} بعد.",
    emptyFilteredTitle: "لا توجد وظائف تطابق هذه الفلاتر",
    emptyFilteredSubtitle:
      "الفلاتر الحالية تستبعد كل النتائج. أزِلها لرؤية الكتالوج كاملاً.",
    emptyClearFilters: "إزالة الفلاتر",
    emptyLiveTitle: "يمكنك البحث مباشرة في مواقع التوظيف",
    emptyLiveBody:
      "ابحث عن نتائج حديثة من وظائف Google لأدوارك المستهدفة، وأضف الوظائف الجديدة إلى هذه القائمة.",
    emptyFetchCta: "جلب وظائف مباشرة",
    emptyFetchingLabel: "جارٍ البحث في مواقع التوظيف…",
    emptyFetchingNote: "قد يستغرق ذلك حتى دقيقة.",
    emptyFetchCreditNote_one: "يستهلك رصيداً واحداً",
    emptyFetchCreditNote_other: "يستهلك {{count}} رصيد",
    // Only the two categories English also has: the copy-coverage test requires
    // identical key sets across locales, and i18next falls back to `_other` for
    // the Arabic categories not listed here.
    emptyFetchSuccess_one: "تم العثور على وظيفة جديدة",
    emptyFetchSuccess_other: "تم العثور على {{count}} وظيفة جديدة",
    emptyFetchNoResults: "لا توجد إعلانات جديدة الآن. حاول لاحقاً.",
    emptyFetchFailed: "تعذّر البحث في مواقع التوظيف",
    emptyEditSkillsCta: "تحديث مهاراتي",
    noExplore: "لا توجد وظائف في السوق",
    noExploreSubtitle: "جرّب بحثاً مختلفاً أو خفف الفلاتر لرؤية وظائف أكثر.",
    noSaved: "لا توجد وظائف محفوظة بعد",
    noSavedSubtitle: "احفظ الوظائف من لك أو السوق لمقارنتها لاحقاً.",
    filters: {
      title: "الفلاتر",
      subtitle: "حسّن الوظائف الظاهرة في لك والسوق.",
      selected: "الفلاتر المحددة",
      activeCount: "{{count}} فلتر نشط",
      activeCount_other: "{{count}} فلاتر نشطة",
      open: "فتح الفلاتر",
      openWithCount: "فتح الفلاتر، {{count}} نشط",
      location: "الموقع",
      locationSearchPlaceholder: "ابحث عن موقع…",
      noLocationsFound: "لم يتم العثور على مواقع",
      useCustom: 'استخدم "{{value}}"',
      workMode: "نمط العمل",
      jobType: "نوع الوظيفة",
      source: "المصدر",
      applyMode: "نوع التقديم",
      easyApply: "بنقرة واحدة / Easy Apply",
      datePosted: "تاريخ النشر",
      clear: "إزالة الفلتر",
      clearAll: "مسح الكل",
      popular: "الأكثر شيوعاً",
      abuDhabi: "أبو ظبي",
      dubai: "دبي",
      sharjah: "الشارقة",
      ajman: "عجمان",
      rak: "رأس الخيمة",
      onSite: "حضوري",
      hybrid: "هجين",
      remote: "عن بُعد",
      fullTime: "دوام كامل",
      partTime: "دوام جزئي",
      contract: "عقد",
      internship: "تدريب",
      today: "اليوم",
      thisWeek: "هذا الأسبوع",
      thisMonth: "هذا الشهر",
    },
    status: {
      applied: "تم التقديم",
      submitted: "تم التقديم",
      redirected: "قيد التقديم",
      not_applied: "لم يتم التقديم",
      reviewed: "تمت المراجعة",
      shortlisted: "في القائمة المختصرة",
      interview: "مقابلة",
      offered: "تم تقديم عرض",
      rejected: "مرفوض",
      withdrawn: "تم السحب",
    },
    filterChips: {
      all: "الكل",
      applied: "تم التقديم",
      inProgress: "قيد التقديم",
    },
    confirmPrompt: {
      title: "هل أكملت التقديم؟",
      body: "فتحنا طلب التقديم لوظيفة {{title}} في {{company}}. أخبرنا بالنتيجة لنحافظ على دقة قائمتك.",
      yesApplied: "نعم، قدّمت",
      notApplied: "لا، لم أقدّم",
      askLater: "اسألني لاحقًا",
      error: "تعذّر تحديث حالة التقديم. يرجى المحاولة مرة أخرى.",
    },
    loading: "جارٍ تحميل الوظائف…",
    loadError: "تعذر تحميل الوظائف",
    loadErrorSubtitle: "يرجى المحاولة مرة أخرى بعد قليل.",
    notFound: "الوظيفة غير موجودة",
    notFoundSubtitle: "قد تكون هذه الوظيفة أزيلت أو لم تعد نشطة.",
    apply: "تقدّم",
    applied: "تم التقديم",
    externalApply: "افتح التقديم الخارجي",
    matchScore: "تطابق {{score}}٪",
    appliedOn: "تم التقديم في {{date}}",
    aiTools: {
      title: "أدوات الذكاء لهذه الوظيفة",
      ask: "اسأل Tabbio AI",
      askBody: "افتح المحادثة مع سياق هذه الوظيفة.",
      packet: "حزمة التقديم",
      packetBody: "خصّص السيرة وخطاب التقديم وملاحظات التحضير.",
      coverLetter: "خطاب التقديم",
      coverLetterBody: "اكتب خطاباً مركزاً من إعلان الوظيفة.",
      interview: "تحضير المقابلة",
      interviewBody: "أنشئ أسئلة متوقعة وزوايا إجابة.",
      askPromptTitle:
        "ساعدني على التقديم لهذه الوظيفة: {{title}} لدى {{company}}.",
      promptJobIdLabel: "معرّف الوظيفة في الكتالوج",
      promptLocationLabel: "الموقع",
      promptDescriptionLabel: "وصف الوظيفة",
      askPromptInstruction:
        "استخدم ملفي وسيري الذاتية المحفوظة في Tabbio لهذه الوظيفة. تابع مباشرة بخطوات مفيدة، وخصّص سيرتي إذا طلبت ذلك.",
      packetPrompt: "أنشئ سيرة مخصصة وحزمة تقديم لهذه الوظيفة.",
      coverLetterPrompt:
        "ركّز على خطاب تقديم موجز وجاهز للمُوظِّف لهذه الوظيفة.",
      interviewPrompt: "أنشئ أسئلة مقابلة متوقعة وزوايا إجابة قوية.",
    },
    smartApply: {
      title: "SmartApply",
      assist: {
        title: "التقديم مع Tabbio",
        heading: "دع Tabbio يجهز هذا الطلب",
        body: "اختر سيرة ذاتية لوظيفة {{title}} لدى {{company}}. ستراجع نموذج صاحب العمل مع Tabbio قبل تعبئة أي معلومات.",
        cvLabel: "السيرة الذاتية لهذا الطلب",
        noCv: "أنشئ سيرة ذاتية أولاً",
        noteLabel: "هل هناك ما يجب أن يعرفه Tabbio؟",
        notePlaceholder: "سياق اختياري لهذا الطلب فقط",
        checking: "جارٍ التحقق من Tabbio Apply...",
        ready:
          "سيعبئ Tabbio النموذج ويرفق هذه السيرة. يمكنك تعديل كل إجابة في نموذج صاحب العمل، ولن يرسل Tabbio الطلب نيابة عنك.",
        connectRequired: "اربط الإضافة المثبتة بحساب Tabbio قبل المتابعة.",
        installRequired:
          "ثبّت Tabbio Apply لمراجعة نموذج صاحب العمل وتعبئته من هذه الوظيفة.",
        openFailed: "تعذر فتح Tabbio Apply",
        opening: "جارٍ فتح طلب التقديم...",
        continue: "المتابعة مع Tabbio Apply",
        connect: "ربط Tabbio Apply",
        install: "تثبيت Tabbio Apply",
        manual: "المتابعة من دون تعبئة تلقائية",
        primary: "التقديم مع Tabbio",
        nativeBody:
          "اختر سيرة ذاتية وسيعبئ Tabbio نموذج صاحب العمل الظاهر مباشرة. يمكنك تعديل كل شيء بعد ذلك.",
        analyze: "تعبئة طلب التقديم",
        analyzing: "جارٍ تجهيز طلبك",
        analyzingBody:
          "يقرأ Tabbio النموذج الظاهر ويجهز الإجابات وينشئ سيرتك الذاتية المحددة.",
        fill: "تعبئة طلب التقديم",
        filling: "جارٍ تعبئة طلب التقديم...",
        fillingBody:
          "يضيف Tabbio بياناتك ويجيب عن الأسئلة المتاحة ويرفق سيرتك الذاتية.",
        retry: "إعادة قراءة النموذج",
        noFormTitle: "لم يتم العثور على نموذج تقديم",
        noFormBody:
          "افتح نموذج التقديم أو الخطوة التالية في هذه الصفحة ثم حاول مرة أخرى.",
        formChanged:
          "تغير نموذج صاحب العمل. اقرأ الخطوة الحالية مرة أخرى قبل التعبئة.",
        attachFailed:
          "تم تجهيز بياناتك، لكن تعذر إرفاق السيرة الذاتية المحددة. حاول مرة أخرى قبل المتابعة.",
        attachFallbackTitle: "تمت تعبئة بياناتك",
        attachFallbackBody:
          "تعذر على Tabbio إرفاق هذه السيرة تلقائياً. اضغط على حقل السيرة وارفعها يدوياً قبل إرسال الطلب.",
        nothingToFill:
          "لم يجد Tabbio أي حقول يمكنه تعبئتها بأمان في هذه الخطوة.",
        nativeCta: "التعبئة مع Tabbio",
        nativeCtaHint: "عبئ النموذج وأرفق سيرتك الذاتية",
        allowanceRemaining: "متبقي {{count}} من التعبئات المجانية هذا الشهر",
        allowanceLast: "هذه آخر تعبئة مجانية هذا الشهر",
        allowancePaid: "تعبئة SmartApply غير محدودة مع {{plan}}",
        allowanceUpgradeHint: "تشمل خطتا Plus وPro تعبئة غير محدودة.",
        checkingForm: "جارٍ البحث عن نموذج التقديم في هذه الصفحة",
        openEmployerForm: "افتح نموذج التقديم لدى صاحب العمل أولاً",
      },
      fallbackTitle: "طلب التقديم",
      fallbackCompany: "الشركة",
      openToolkit: "فتح أدوات SmartApply",
      loading: "جارٍ تحميل صفحة التقديم…",
      webFallbackTitle:
        "يفتح SmartApply طلبات التقديم الخارجية في المتصفح على الويب.",
      aiAssist: "مساعدة AI",
      aiAssistBody: "اطلب إجابات أو خطوات تالية أو صياغة جاهزة للمُوظِّف.",
      applicationPack: "حزمة التقديم",
      applicationPackBody:
        "أنشئ توافق السيرة وخطاب التقديم وتحضير المقابلة وقائمة التحقق.",
      externalBrowser: "متصفح خارجي",
      externalBrowserBody: "افتح هذه الصفحة خارج Tabbio.",
      translate: "ترجمة",
      translateBody: "اختر لغة لصفحة التقديم هذه.",
      translateBack: "الرجوع إلى أدوات SmartApply",
      translateSheetTitle: "ترجمة الصفحة",
      translateSheetSubtitle: "اختر اللغة",
      translatePickerHint:
        "سيتم إعادة تحميل الصفحة عبر Google Translate داخل SmartApply.",
      translateLanguages: {
        arabic: "العربية",
        english: "الإنجليزية",
        urdu: "الأردية",
        hindi: "الهندية",
        persian: "الفارسية",
        french: "الفرنسية",
      },
      translateLanguageNative: {
        arabic: "العربية",
        english: "English",
        urdu: "اردو",
        hindi: "हिन्दी",
        persian: "فارسی",
        french: "Français",
      },
      settings: "الإعدادات",
      settingsBody: "عدّل تفضيلات الملف والتقديم.",
      aiAssistConfirmTitle: "هل تريد سؤال Tabbio AI عن هذه الوظيفة؟",
      aiAssistConfirmBody:
        "سنفتح المحادثة مع إرفاق هذه الوظيفة حتى يساعدك Tabbio AI في الخطوات التالية أو خطاب التقديم أو التحضير للمقابلة.",
      aiAssistConfirmCta: "اسأل AI",
      confirmTitle: "هل أنهيت التقديم؟",
      confirmBody:
        "علّم هذه الوظيفة كمتقدم لها فقط إذا أرسلت طلبك على موقع صاحب العمل.",
      applied: "تم التقديم",
      notApplied: "لم أتقدم",
      keepApplying: "متابعة التقديم",
      confirmFailedTitle: "تعذّر تحديث هذا التقديم",
      confirmFailedBody: "حاول مرة أخرى بعد انتهاء تحميل موقع صاحب العمل.",
      markedApplied: "تم تسجيل التقديم",
      markedNotApplied: "لن تظهر هذه الوظيفة ضمن المتقدم لها",
      aiAssistPromptTitle: "ساعدني على التقديم لـ {{title}} لدى {{company}}.",
      aiPromptDescriptionLabel: "وصف الوظيفة",
      aiPromptPageLabel: "صفحة التقديم",
      aiAssistPromptInstruction:
        "استخدم ملفي وسيري الذاتية المحفوظة في Tabbio لهذا التقديم الخارجي. تابع مباشرة بخطوات مفيدة أو تخصيص السيرة أو مساعدة إجابات الفرز عندما أطلب.",
      applicationPackPrompt:
        "أنشئ حزمة تقديم تتضمن سيرة مخصصة وخطاب تقديم وتحضير مقابلة وإرشادات لإجابات الفرز لهذه الوظيفة.",
    },
    alignment: {
      strong: "متوافقة مع الأدوار المستهدفة",
      medium: "متوافقة مع تفضيلاتك",
      low: "توافق منخفض",
    },
    match: {
      title: "لماذا تظهر هذه الوظيفة",
      family: "الدور: {{family}}",
      skills: "المهارات المطابقة: {{skills}}",
      missingSkills: "المهارات غير المطابقة: {{skills}}",
      completeness: "اكتمال البيانات: {{score}}٪",
      quality: "إشارات الجودة: {{flags}}",
    },
    quality: {
      no_description: "لا يوجد وصف",
      thin_requirements: "متطلبات قليلة",
      low_completeness: "اكتمال منخفض",
      no_skill_overlap: "لا يوجد توافق في المهارات",
      low_confidence: "ثقة منخفضة",
      surface_ineligible: "مخفية من الاكتشاف",
    },
    noJobs: "لا توجد وظائف",
    noJobsSubtitle: "لا توجد وظائف نشطة حالياً. تحقق مرة أخرى قريباً.",
    noJobsFilteredSubtitle: "جرّب إزالة بعض الفلاتر لعرض وظائف أكثر.",
    noApplied: "لا توجد طلبات بعد",
    noAppliedSubtitle: "ستظهر الوظائف التي تقدمت لها هنا",
    locationFallback: "الموقع غير محدد",
    description: "الوصف",
    skills: "المهارات",
    requirements: "المتطلبات",
    screeningQuestions: "أسئلة الفرز",
    detailLabels: {
      type: "نوع الوظيفة",
      workMode: "نمط العمل",
      level: "المستوى",
      location: "الموقع",
      posted: "نُشر",
      source: "المصدر",
    },
    applySheet: {
      title: "التقديم على الوظيفة",
      smartCvTitle: "أرسل سيرتك الذاتية",
      smartCvLabel: "السيرة الذاتية",
      smartCvBody: "أنت تتقدم لوظيفة {{jobTitle}} لدى {{company}}.",
      smartCvNotice:
        "تُرسَل نسخة ثابتة من سيرتك الذاتية مع هذا الطلب. أي تعديل تجريه على سيرتك لاحقاً لن يغيّر النسخة التي يراها المُوظِّف.",
      smartApplyBadge: "سمارت أبلاي",
      changeResume: "تغيير",
      chooseCv: "اختر السيرة الذاتية",
      chooseCvHint: "اختر أي سيرة ذاتية مخصصة تريد إرسالها مع هذا الطلب.",
      screening: "أسئلة الفرز",
      screeningHint: "أجب عن جميع الأسئلة المطلوبة قبل إرسال الطلب.",
      questionNumber: "السؤال {{number}}",
      answerPlaceholder: "اكتب إجابتك…",
      numberPlaceholder: "أدخل رقمًا",
      optionalLabel: "اختياري",
      yes: "نعم",
      no: "لا",
      updatedOn: "آخر تحديث {{date}}",
      noScreening: "لا توجد أسئلة فرز إضافية لهذه الوظيفة.",
      noCvTitle: "لا توجد سيرة ذاتية متاحة",
      noCvBody: "أنشئ سيرة ذاتية مخصصة قبل إرسال هذا الطلب.",
      createCv: "إنشاء سيرة ذاتية",
      submit: "تأكيد وإرسال الطلب",
      submitting: "جارٍ الإرسال…",
      submitSuccess: "تم إرسال الطلب",
      successTitle: "تم إرسال الطلب",
      successBody: "طلبك لوظيفة {{jobTitle}} في طريقه إلى {{company}}.",
      successNextTitle: "ما الذي سيحدث بعد ذلك",
      successNextReview:
        "تراجع {{company}} الطلبات داخل Tabbio وستتواصل معك عبر البريد الإلكتروني.",
      successNextTrack:
        "يبقى هذا الطلب، والنسخة الثابتة من سيرتك التي أرسلتها معه، في «وظائفي».",
      viewApplication: "عرض في وظائفي",
      submitError: "تعذر إرسال الطلب",
      cancel: "إلغاء",
      cvUsed: "تم التقديم باستخدام {{title}}",
    },
    // نوافذ الموافقة بنمط «الربط» (صفحة الشركة العامة ← داخل التطبيق).
    connectShare: {
      label: "سيُشارك مع {{company}}",
      nameLabel: "الاسم",
      emailLabel: "البريد الإلكتروني",
      cvLabel: "السيرة الذاتية",
    },
    connectApply: {
      title: "التقديم على {{jobTitle}}",
      submit: "تقديم",
      submitting: "جارٍ التقديم…",
      consent:
        "أوافق على أن تعالج Tabbio بياناتي وتشارك اسمي وبريدي الإلكتروني وسيرتي الذاتية مع {{company}} للنظر في طلبي.",
      successTitle: "تم إرسال الطلب",
      successBody: "استلمت {{company}} طلبك لوظيفة {{jobTitle}}.",
      alreadyAppliedTitle: "سبق أن تقدمت",
      alreadyAppliedBody:
        "سبق أن تقدمت على هذه الوظيفة — طلبك محفوظ لدى {{company}}.",
      viewApplication: "عرض في وظائفي",
    },
    connectJoin: {
      title: "الانضمام إلى شبكة مواهب {{company}}",
      submit: "انضمام",
      submitting: "جارٍ الانضمام…",
      consent:
        "أوافق على أن تحتفظ {{company}} بملفي وسيرتي الذاتية المُرسلة في شبكة المواهب لديها وأن تنظر في ترشيحي لفرص لاحقة. يمكنني الانسحاب في أي وقت من داخل Tabbio.",
      successTitle: "أنت الآن ضمن الشبكة",
      successBody: "أصبح بإمكان {{company}} النظر في ترشيحك لفرص مستقبلية.",
      alreadyActiveTitle: "أنت عضو بالفعل",
      alreadyActiveBody: "أنت بالفعل ضمن شبكة مواهب {{company}}.",
      submitError: "تعذر الانضمام إلى شبكة المواهب",
      loadError: "تعذر تحميل بيانات هذه الشركة",
      loadErrorSubtitle: "تحقق من اتصالك بالإنترنت ثم أعد المحاولة.",
    },
    // رفض الخادم الذي قد تتلقاه أي واجهة تقديم (نوافذ التقديم، ونوافذ الربط
    // للتقديم والانضمام). مفاتيحها حسب رمز خطأ الـ API في lib/apply-error.ts؛
    // الرموز غير المعروفة تعود إلى رسالة الخادم.
    applyErrors: {
      cvResolutionFailed:
        "تعذر قراءة سيرتك الذاتية الآن، ولم يُرسل أي شيء. يرجى المحاولة مرة أخرى.",
      cvEmpty:
        "لا تحتوي هذه السيرة الذاتية على محتوى لإرساله بعد. اختر سيرة ذاتية أخرى أو أضف بياناتك ثم أعد المحاولة.",
      cvBelongsToClient:
        "هذه السيرة الذاتية تخص أحد عملائك، لذا لا يمكن استخدامها كسيرتك الخاصة. اختر إحدى سيرك الذاتية.",
      jobExternalOnly:
        "تستقبل هذه الوظيفة الطلبات عبر موقع صاحب العمل، وليس من خلال Tabbio.",
      notAccepting: "لا تستقبل هذه الشركة الطلبات عبر Tabbio بعد.",
    },
  },

  // Candidates / Find Talent
  candidates: {
    title: "البحث عن مواهب",
    detailHeaderFallback: "مرشّح",
    searchPlaceholder: "الاسم، المسمى، المهارة…",
    tabs: {
      browse: "تصفح",
      shortlisted: "القائمة المختصرة",
    },
    filters: {
      experience: "الخبرة",
      location: "الموقع",
      availability: "التوفر",
      junior: "٠–٢ سنة",
      mid: "٣–٥ سنوات",
      senior: "٦–١٠ سنوات",
      executive: "+١٠ سنوات",
      abuDhabi: "أبو ظبي",
      dubai: "دبي",
      sharjah: "الشارقة",
      remote: "عن بُعد",
      immediate: "فوري",
      twoWeeks: "أسبوعين",
      oneMonth: "شهر",
      threeMonths: "٣ أشهر",
    },
    status: {
      new: "جديد",
      contacted: "تم التواصل",
      interviewing: "مقابلة",
      offered: "عرض",
      rejected: "مرفوض",
    },
    view: "عرض",
    shortlist: "إضافة للقائمة",
    shortlistedAction: "ضمن القائمة المختصرة",
    match: "تطابق {{value}}٪",
    experience: "الخبرة",
    skills: "المهارات",
    about: "نبذة",
    details: {
      availability: "التوفر",
      source: "المصدر",
      activity: "النشاط",
      status: "الحالة",
    },
    noCandidates: "لا يوجد مرشحون",
    noCandidatesSubtitle: "جرّب تعديل الفلاتر أو تحقق لاحقاً",
    noShortlisted: "لا يوجد مرشحون في القائمة المختصرة",
    noShortlistedSubtitle: "سيظهر المرشحون الذين تضيفهم للقائمة هنا",
    shortlistedAgo: "أضيف {{time}}",
  },

  profile: {
    title: "الملف الشخصي",
  },

  messages: {
    title: "الرسائل",
    emptyTitle: "لا توجد رسائل بعد",
    emptySubtitle: "ستظهر رسائل مسؤولي التوظيف وأصحاب العمل هنا",
  },

  studioTools: {
    copy: "نسخ",
    copied: "تم النسخ",
    copyFailed: "تعذر النسخ",
    cvScore: {
      title: "تقييم السيرة Pro",
      subtitle:
        "قيّم سيرتك مقابل دور خليجي مستهدف، إشارات ATS، الأدلة الناقصة، ومخاطر مسؤول التوظيف.",
      outcomeFit: "درجة إرشادية لملاءمة الخليج وقابلية القراءة في ATS",
      outcomeProof: "المهارات والأدوات والشهادات الناقصة",
      outcomeMoves: "تحسينات يلاحظها مسؤول التوظيف",
      generate: "توليد تقييم السيرة",
      rolePlaceholder: "مثال: محاسب أول",
    },
    coverLetter: {
      title: "خطاب التعريف",
      subtitle:
        "حوّل الدور والشركة وأدلتك المهنية إلى خطاب مركّز يمكنك تعديله وإرساله.",
      outcomeOpening: "افتتاحية مخصصة للدور",
      outcomeEvidence: "أدلة ذات صلة من خبرتك",
      outcomeClose: "خاتمة واثقة وموجزة",
      generate: "توليد خطاب التعريف",
      rolePlaceholder: "مثال: محاسب أول",
    },
    interviewPrep: {
      title: "التحضير للمقابلة",
      subtitle:
        "أنشئ أسئلة محتملة ونقاط حديث مدعومة بالأدلة وخطة تحضير عملية لهذا الدور.",
      outcomeQuestions: "أسئلة محتملة عن الدور والشركة",
      outcomeStories: "قصص إجابات مدعومة بالأدلة",
      outcomePlan: "خطة تحضير مركزة",
      generate: "توليد تحضير المقابلة",
      rolePlaceholder: "مثال: مدير منتجات",
    },
    salaryInsights: {
      title: "رؤى الرواتب",
      subtitle: "قدّر نطاق راتب عملي في الخليج مع مستوى الثقة ونص تفاوض.",
      outcomeRange: "النطاق الأدنى والمتوسط والأعلى",
      outcomeConfidence: "الثقة وتنبيهات المستوى",
      outcomeScript: "نص تفاوض قابل للتعديل",
      generate: "توليد تقرير الراتب",
      rolePlaceholder: "مثال: مهندس خلفية",
    },
    applicationPack: {
      title: "حزمة التقديم",
      subtitle:
        "أنشئ الحزمة المدفوعة كاملة: ملاءمة السيرة، خطاب التغطية، إجابات الفرز، التحضير، الراتب، معاينة التوظيف، والقائمة.",
      outcomePacket: "السيرة والخطاب والراتب والتحضير",
      outcomeAnswers: "إجابات الفرز وقراءة مسؤول التوظيف",
      outcomeChecklist: "قائمة مراجعة قبل التقديم",
      generate: "توليد حزمة التقديم",
      rolePlaceholder: "مثال: مدير منتجات",
    },
    recruiterPreview: {
      title: "معاينة مسؤول التوظيف",
      subtitle:
        "اعرف كيف قد يقرأ أصحاب العمل ملفك، الأدلة الظاهرة، الحقول المتحققة، ومخاطر المطابقة.",
      outcomeRead: "ملخص كما يراه مسؤول التوظيف",
      outcomeRisks: "مخاطر الترتيب والمطابقة",
      outcomeEvidence: "الأدلة الناقصة التي يجب إضافتها",
      generate: "توليد معاينة التوظيف",
      rolePlaceholder: "مثال: مدير مبيعات",
    },
    form: {
      inputs: "المدخلات",
      context: "السياق",
      generating: "جارٍ بناء المخرج…",
      role: "الدور المستهدف",
      company: "الشركة",
      companyPlaceholder: "مثال: بنك الإمارات دبي الوطني",
      country: "الدولة",
      countrySearchPlaceholder: "ابحث عن دولة...",
      seniority: "المستوى",
      seniorityJunior: "مبتدئ",
      seniorityMid: "متوسط",
      senioritySenior: "أول",
      seniorityLead: "قيادي",
      jobDescription: "وصف الوظيفة",
      jobDescriptionPlaceholder:
        "ألصق إعلان الوظيفة أو المسؤوليات أو المتطلبات هنا",
      notes: "ملاحظات",
      notesPlaceholder: "أضف تفضيل التأشيرة، النبرة، الفجوات، أو أي أمر مهم",
    },
    results: {
      latest: "آخر نتيجة",
      empty: "لا توجد مخرجات بعد",
      emptyTitle: "ولّد أول مخرج",
      emptyBody: "أدخل الدور المستهدف وأنشئ المخرج. ستظهر نتائجك المحفوظة هنا.",
      savedArtifact: "مخرج محفوظ من Studio",
      cvScore: "تقييم السيرة",
      overall: "الإجمالي",
      gccFit: "ملاءمة الخليج",
      ats: "ATS",
      strengths: "نقاط القوة",
      missingSkills: "المهارات الناقصة",
      nextActions: "الخطوات التالية",
      salary: "تقرير الراتب",
      low: "الأدنى",
      median: "المتوسط",
      high: "الأعلى",
      marketNotes: "ملاحظات السوق",
      confidence: "الثقة",
      recruiterPreview: "معاينة التوظيف",
      profileScore: "درجة الملف",
      visibleStrengths: "نقاط القوة الظاهرة",
      concerns: "المخاوف",
      missingEvidence: "الأدلة الناقصة",
      questions: "الأسئلة",
      highlights: "النقاط البارزة",
      steps: "الخطوات",
      blockers: "العوائق",
      ready: "جاهز",
      needsReview: "بحاجة للمراجعة",
    },
    errors: {
      generateTitle: "تعذر التوليد",
      generateBody: "حاول مرة أخرى بدور أو دولة أو وصف وظيفة أوضح.",
    },
  },

  // Cover Letters service
  coverLetters: {
    title: "خطابات التغطية",
    subtitle: "أنشئ خطابات تغطية مخصصة وعدّلها وأعد استخدامها",
    create: "خطاب جديد",
    createTitle: "خطاب تغطية جديد",
    createSubtitle: "أخبرنا أين تتقدم: وسنكتب لك المسودة",
    recent: "الأحدث",
    notFound: "لم يتم العثور على الخطاب",
    deleteConfirm: "حذف هذا الخطاب؟",
    copied: "تم النسخ",
    saved: "تم الحفظ",
    regenerated: "تمت إعادة التوليد",
    generateFailedTitle: "تعذر توليد خطاب التغطية",
    generateFailedMessage: "حاول مرة أخرى بدور أو شركة أوضح.",
    regenerate: "إعادة توليد",
    edit: "تحرير",
    copy: "نسخ",
    share: "مشاركة",
    calloutTitle: "اكتب خطاباً مخصصاً",
    calloutBody:
      "ألصق رابط الوظيفة أو أضف بعض التفاصيل: وسيكتب Tabbio خطاباً يطابق الدور.",
    emptyTitle: "لا توجد خطابات بعد",
    emptySubtitle: "أنشئ خطابك الأول لتسريع تقديماتك.",
    row: {
      meta: "{{role}} · {{company}} · {{tone}}",
    },
    detail: {
      meta: "{{role}} في {{company}}",
    },
    tone: {
      professional: "احترافي",
      enthusiastic: "متحمس",
      concise: "موجز",
      storytelling: "سردي",
    },
    form: {
      company: "الشركة",
      companyPlaceholder: "مثال: ستريب",
      role: "الدور",
      rolePlaceholder: "مثال: مصمم منتجات أول",
      tone: "النبرة",
      notes: "ملاحظات (اختياري)",
      notesPlaceholder: "شارك ما يجعلك مناسباً، روابط، أو أي شيء تريد إبرازه",
      generate: "توليد بالذكاء الاصطناعي",
    },
  },

  // Interview Prep service
  interviewPrep: {
    title: "التحضير للمقابلة",
    subtitle:
      "تدرّب مع الذكاء الاصطناعي واحصل على ملاحظات قبل المقابلة الفعلية",
    startNew: "ابدأ جلسة",
    createTitle: "جلسة مقابلة جديدة",
    createSubtitle: "اختر مساراً، أخبرنا عن الدور، وسنحضّر الأسئلة.",
    notFound: "لم يتم العثور على الجلسة",
    deleteConfirm: "حذف هذه الجلسة؟",
    generateFailedTitle: "تعذر إنشاء تحضير المقابلة",
    generateFailedMessage: "حاول مرة أخرى بدور أو شركة أوضح.",
    answered: "تمت الإجابة",
    skip: "تخطي",
    submitAndNext: "إرسال والتالي",
    finish: "إنهاء الجلسة",
    scoring: "جارٍ التقييم…",
    showHint: "إظهار تلميح المدرّب",
    hideHint: "إخفاء التلميح",
    yourAnswer: "إجابتك",
    answerPlaceholder: "تدرّب على الإجابة بصوت عالٍ، ثم اكتب فكرتها هنا…",
    feedbackTitle: "ملاحظات المدرّب",
    questionLabel: "السؤال {{index}} من {{total}}",
    allQuestions: "كل الأسئلة",
    heroBadge: "مدرّب المقابلات الذكي",
    heroTitle: "تدرّب على الجولة القادمة",
    heroSubtitle:
      "اختر مساراً، شغّل جلسة 30 دقيقة، واحصل على ملاحظات لكل إجابة.",
    sections: {
      tracks: "المسارات",
      recent: "الجلسات الأخيرة",
    },
    tracks: {
      behavioral: {
        title: "سلوكية",
        subtitle: "قصص بأسلوب STAR عن القيادة والمسؤولية والخلافات.",
      },
      technical: {
        title: "تقنية",
        subtitle: "تدريبات برمجية وتصحيح أخطاء وأنماط معمارية.",
      },
      systemDesign: {
        title: "تصميم الأنظمة",
        subtitle: "جولات تصميم عالية المستوى على السبورة.",
      },
      screening: {
        title: "مكالمة فرز",
        subtitle: "تعريف سريع، الدوافع، وأسئلة الملاءمة.",
      },
    },
    kind: {
      behavioral: "سلوكية",
      technical: "تقنية",
      systemDesign: "تصميم الأنظمة",
      screening: "مكالمة فرز",
    },
    kindDesc: {
      behavioral: "قصص عن القيادة والحكم.",
      technical: "تدريبات برمجية ومعمارية.",
      systemDesign: "أسئلة تصميم على السبورة.",
      screening: "تعريف وأسئلة ملاءمة.",
    },
    status: {
      draft: "مسودة",
      in_progress: "قيد التقدّم",
      completed: "مكتملة",
    },
    row: {
      progress: "تمت الإجابة على {{answered}} من {{total}}",
    },
    form: {
      kind: "المسار",
      role: "الدور",
      rolePlaceholder: "مثال: مدير منتجات أول",
      company: "الشركة (اختياري)",
      companyPlaceholder: "مثال: ستريب",
      duration: "المدة",
      minutes_one: "{{count}} دقيقة",
      minutes_other: "{{count}} دقيقة",
      start: "بدء الجلسة",
    },
    feedback: {
      short: "بداية جيدة: تعمّق أكثر. أضف المقايضة المحددة والنتيجة الرقمية.",
      tighten: "محتوى قوي. اختصره: احذف الفقرة الوسطى وابدأ بالنتيجة.",
      solid:
        "إجابة واضحة ومنظّمة. أنهِها بجملة ختامية حادة: ما الذي تغيّر بفضلك؟",
    },
    toasts: {
      next: "تم الحفظ. السؤال التالي.",
      completed: "اكتملت الجلسة. راجع ملاحظاتك.",
    },
  },
  searchArea: {
    title: "الموقع والنطاق",
    searchPlaceholder: "ابحث عن مدينة أو منطقة أو عنوان",
    useCurrent: "استخدم موقعي الحالي",
    confirm: "تأكيد الموقع",
    distanceTitle: "أقصى مسافة من موقعك",
    distanceHelper:
      "تظهر الوظائف ضمن {{km}} كم أولاً. تستمر القوائم الأبعد في الظهور بالأسفل.",
    preferredLocations: "المواقع المفضلة",
    add: "الموقع",
    addAnother: "إضافة موقع آخر",
    helper: 'يُستخدم هذا النطاق أيضاً لترتيب وظائف "لك" في البحث.',
    furtherDivider: "وظائف من مسافات أبعد",
    furtherHelper:
      "تتجاوز نطاق {{km}} كم المفضل: لا تزال مطابقات قوية، لكنها أبعد.",
    setLocationTitle: "حدّد موقعًا مفضّلًا لترتيب الوظائف",
    setLocationCta: "اختر موقعًا",
    distanceFrom: "تبعد {{km}} كم",
    saveFailedTitle: "تعذّر حفظ الموقع",
    saveFailedSubtitle: "تحقّق من اتصالك ثم أعد المحاولة.",
    withinHint: "وظائف ضمن {{km}} كم من {{city}} تظهر أولاً.",
    map: "خريطة",
    satellite: "قمر صناعي",
    centerOnPin: "توسيط على الدبوس",
  },
  cvAnalytics: {
    historyWindow: 'يحتفظ السجل الأقدم بالأعداد اليومية. تشمل الأنشطة المسماة والزوار الفريدون آخر {{days}} يومًا.',
    recruiterViewsLine_zero: "لا مشاهدات من مسؤولي التوظيف",
    recruiterViewsLine_one: "مشاهدة واحدة من مسؤولي التوظيف",
    recruiterViewsLine_two: "مشاهدتان من مسؤولي التوظيف",
    recruiterViewsLine_few: "{{count}} مشاهدات من مسؤولي التوظيف",
    recruiterViewsLine_many: "{{count}} مشاهدةً من مسؤولي التوظيف",
    recruiterViewsLine_other: "{{count}} مشاهدة من مسؤولي التوظيف",
    recruiterCompanies_zero: "من {{count}} شركة",
    recruiterCompanies_one: "من شركة واحدة",
    recruiterCompanies_two: "من شركتين",
    recruiterCompanies_few: "من {{count}} شركات",
    recruiterCompanies_many: "من {{count}} شركةً",
    recruiterCompanies_other: "من {{count}} شركة",
    recruiterSearchesLine_zero: "لم تظهر في أي عملية بحث لمسؤولي التوظيف",
    recruiterSearchesLine_one: "ظهرت في عملية بحث واحدة لمسؤولي التوظيف",
    recruiterSearchesLine_two: "ظهرت في عمليتي بحث لمسؤولي التوظيف",
    recruiterSearchesLine_few: "ظهرت في {{count}} عمليات بحث لمسؤولي التوظيف",
    recruiterSearchesLine_many: "ظهرت في {{count}} عمليةَ بحث لمسؤولي التوظيف",
    recruiterSearchesLine_other: "ظهرت في {{count}} عملية بحث لمسؤولي التوظيف",
    keywordsTitle: "الكلمات التي بحث بها مسؤولو التوظيف",
    keywordsEmpty:
      "لم يظهر ملفك في عمليات بحث مسؤولي التوظيف بعد. ابقَ قابلًا للاكتشاف وحدّث مهاراتك باستمرار ليجدك أصحاب العمل.",
    keywordsPending: "تظهر الكلمات هنا عندما تبحث بها أكثر من شركة واحدة.",
    keywordSearches_zero: "لا عمليات بحث",
    keywordSearches_one: "عملية بحث واحدة",
    keywordSearches_two: "عمليتا بحث",
    keywordSearches_few: "{{count}} عمليات بحث",
    keywordSearches_many: "{{count}} عمليةَ بحث",
    keywordSearches_other: "{{count}} عملية بحث",
    keywordViews_zero: "لا مشاهدات",
    keywordViews_one: "مشاهدة واحدة",
    keywordViews_two: "مشاهدتان",
    keywordViews_few: "{{count}} مشاهدات",
    keywordViews_many: "{{count}} مشاهدةً",
    keywordViews_other: "{{count}} مشاهدة",
    whereFrom: "من أين هم",
    howFound: "كيف وجدوك",
    emptyBreakdown: "لا يوجد تفصيل متاح بعد.",
    metric: {
      views: "المشاهدات",
      downloads: "التنزيلات",
      shares: "المشاركات",
    },
    trend: {
      newLabel: "جديد",
      new_zero: "جديد في آخر {{count}} يوم",
      new_one: "جديد في آخر يوم واحد",
      new_two: "جديد في آخر يومين",
      new_few: "جديد في آخر {{count}} أيام",
      new_many: "جديد في آخر {{count}} يومًا",
      new_other: "جديد في آخر {{count}} يوم",
      up_zero: "ارتفاع {{percent}}٪: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
      up_one: "ارتفاع {{percent}}٪: آخر يوم واحد مقارنة بالفترة نفسها قبلها",
      up_two: "ارتفاع {{percent}}٪: آخر يومين مقارنة بالفترة نفسها قبلها",
      up_few: "ارتفاع {{percent}}٪: آخر {{count}} أيام مقارنة بالفترة نفسها قبلها",
      up_many: "ارتفاع {{percent}}٪: آخر {{count}} يومًا مقارنة بالفترة نفسها قبلها",
      up_other: "ارتفاع {{percent}}٪: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
      down_zero: "انخفاض {{percent}}٪: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
      down_one: "انخفاض {{percent}}٪: آخر يوم واحد مقارنة بالفترة نفسها قبلها",
      down_two: "انخفاض {{percent}}٪: آخر يومين مقارنة بالفترة نفسها قبلها",
      down_few: "انخفاض {{percent}}٪: آخر {{count}} أيام مقارنة بالفترة نفسها قبلها",
      down_many: "انخفاض {{percent}}٪: آخر {{count}} يومًا مقارنة بالفترة نفسها قبلها",
      down_other: "انخفاض {{percent}}٪: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
      flat_zero: "بلا تغيير: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
      flat_one: "بلا تغيير: آخر يوم واحد مقارنة بالفترة نفسها قبلها",
      flat_two: "بلا تغيير: آخر يومين مقارنة بالفترة نفسها قبلها",
      flat_few: "بلا تغيير: آخر {{count}} أيام مقارنة بالفترة نفسها قبلها",
      flat_many: "بلا تغيير: آخر {{count}} يومًا مقارنة بالفترة نفسها قبلها",
      flat_other: "بلا تغيير: آخر {{count}} يوم مقارنة بالفترة نفسها قبلها",
    },
    activityAction: {
      views: "شاهد سيرتك الذاتية",
      downloads: "نزّل سيرتك الذاتية",
      shares: "شارك سيرتك الذاتية",
    },
    place: {
      profile: "ملفك الشخصي",
      shareLink: "رابط المشاركة",
      tabbio: "على Tabbio",
    },
    filter: {
      all: "الكل",
      cv: "السيرة الذاتية",
      trigger: "تصفية الإحصاءات",
      group: "فلاتر الإحصاءات",
      duration: "الفترة",
      cvVersion: "نسخة السيرة الذاتية",
      allCvs: "كل السير الذاتية",
      mainCv: "السيرة الأساسية",
      chooseCv: "اختر سيرة ذاتية",
      reset: "إعادة ضبط",
      days: "{{count}} ي",
      done: "تم",
    },
    hub: {
      title: "الإحصاءات",
      close: "إغلاق الإحصاءات",
      metricGroup: "المؤشر",
      chart: "{{metric}} عبر الوقت",
      chartEmpty: {
        views: "لا توجد مشاهدات في هذه الفترة",
        downloads: "لا توجد تنزيلات في هذه الفترة",
        shares: "لا توجد مشاركات في هذه الفترة",
      },
      activity: "النشاط",
      showMore: "عرض المزيد",
      showLess: "عرض أقل",
      privacy: "هوية الزوار المجهولين تبقى مخفية.",
      gettingNoticed: "سيرتك الذاتية تلفت الانتباه",
      noRecentActivity: "لا يوجد نشاط حديث متاح",
      noActivityYet: "لا يوجد نشاط بعد",
      stackCaption: "زوار سيرتك الذاتية",
      viewFullActivity: "عرض النشاط بالكامل",
      explorePremiumActivity: "استكشف بريميوم للنشاط الكامل",
      explorePremium: "استكشف بريميوم",
      seeFullActivity: "شاهد نشاط سيرتك بالكامل",
      fullActivityPremium: "تفاصيل النشاط متاحة مع بريميوم.",
      viewFullAnalytics: "عرض الإحصاءات كاملة",
      showCv: "عرض إحصاءات {{cv}}",
      loading: "جارٍ تحميل الإحصاءات",
      errorTitle: "تعذّر تحميل الإحصاءات",
      errorBody: "حاول مرة أخرى لرؤية نشاطك.",
      tryAgain: "حاول مرة أخرى",
      moreActivity: "نشاط إضافي",
      anonymousVisitor: "زائر مجهول",
      openDetails: "عرض تفاصيل نشاط {{name}}",
      detail: {
        title: "تفاصيل النشاط",
        close: "إغلاق تفاصيل النشاط",
        person: "نشاط الملف الشخصي",
        company: "نشاط الشركة",
        anonymous: "نشاط مجهول مجمّع",
        anonymousTitle: "زوار مجهولون",
        recent: "النشاط الأخير",
        noRecent: "لا يوجد نشاط حديث في هذه الفترة",
        companyNote: "قد يشمل نشاط الشركة أكثر من زائر. المشاهدات داخل Tabbio تُحسب بشكل منفصل عن مشاهدات سيرتك العامة.",
        anonymousNote: "تجمع هذه الأرقام النشاط المجهول، ولا تكشف هوية أي زائر.",
        footnote: "الأرقام تحسب الإجراءات، وليس عدد الزوار الفريدين.",
        companyFootnote: "تُحسب مشاهدة واحدة لكل شركة في اليوم.",
        error: "تعذّر تحميل هذا النشاط.",
        gone: "هذا النشاط لم يعد متاحًا.",
      },
    },
    age: {
      minute_zero: "{{count}} د",
      minute_one: "{{count}} د",
      minute_two: "{{count}} د",
      minute_few: "{{count}} د",
      minute_many: "{{count}} د",
      minute_other: "{{count}} د",
      hour_zero: "{{count}} ساعة",
      hour_one: "ساعة",
      hour_two: "ساعتان",
      hour_few: "{{count}} ساعات",
      hour_many: "{{count}} ساعة",
      hour_other: "{{count}} ساعة",
      day_zero: "{{count}} يوم",
      day_one: "يوم",
      day_two: "يومان",
      day_few: "{{count}} أيام",
      day_many: "{{count}} يومًا",
      day_other: "{{count}} يوم",
    },
    liveSummary:
      "{{scope}}، {{period}}. {{views}} مشاهدة، {{downloads}} تنزيل، {{shares}} مشاركة.",
    range: {
      lastDays_zero: "آخر {{count}} يوم",
      lastDays_one: "آخر يوم",
      lastDays_two: "آخر يومين",
      lastDays_few: "آخر {{count}} أيام",
      lastDays_many: "آخر {{count}} يومًا",
      lastDays_other: "آخر {{count}} يوم",
      allTime: "كل الأوقات",
    },
    source: {
      directLink: "رابط مباشر",
      qr: "رمز QR",
      copy: "رابط منسوخ",
      share: "قائمة المشاركة",
      tabbio: "تابيو",
      email: "البريد الإلكتروني",
    },
    downloadFormat: {
      print: "طباعة / PDF",
    },
  },
} as const;
